/* RRX Cart Drawer – Drawer, Tracking, Recos (max 3), Quick-View mit THEME-SWATCHES
   - Fängt alle Cart-Trigger ab → eigener Drawer
   - Recos: hartes Limit + Dedupe (Design/Handle)
   - Angesehen: duplikatfrei, neueste zuerst
   - Quick-View: echte Theme-Color-Swatches (Bilddateien) bevorzugt; Hex nur Fallback
   - „Black/White“ etc. erzwingen Vollton → kein Theme-Foto mehr
   - Quick-View ohne Preis + Auge-Button für Vollbild (X zum Schließen)
*/
// Cache für Quick-View Daten, um doppeltes Laden zu verhindern
const QV_CACHE = new Map();
const LOOX_CACHE = new Map(); // 🚨 SPEEDSHOP FIX: Cache für Live-Sterne

/* 
  🚨 SPEEDSHOP FIX: getRoute in den globalen Scope (oder über preloadQV) verschoben.
  Shopify Markets Routing & Crash-Schutz ist jetzt global verfügbar, 
  bevor preloadQV ihn aufruft!
*/
const getRoute = (path) => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
    ? window.Shopify.routes.root 
    : '/';
  return (root + path).replace(/\/\//g, '/');
};

function preloadQV(handle){
  if (!handle || QV_CACHE.has(handle)) return;
  // getRoute ist nun bekannt, der Fetch-Call für die Quick-View wird erfolgreich ausgeführt.
  QV_CACHE.set(handle, fetch(getRoute(`products/${encodeURIComponent(handle)}.js`)).then(r=>r.ok?r.json():Promise.reject()));
}

(() => {
  "use strict";

/* === RRX – Gratis-Badge + Gesamtrabatt-Chip (Buy X Get Y) v4.6 === */
(function(){
  console.log('[RRX] CartEnhancements v4.6 loaded');

  /* Styles */
  var SID='rrx-cart-enhance-style';
  if(!document.getElementById(SID)){
    var st=document.createElement('style'); st.id=SID;
    st.textContent =
      '.rrx-free-ui{display:inline-flex;gap:.5rem;align-items:center;white-space:nowrap}'+
      '.rrx-free-ui .rrx-old{text-decoration:line-through;opacity:.7}'+
      '.rrx-free-ui .rrx-tag{display:inline-flex;align-items:center;justify-content:center;'+
      'padding:.1rem .5rem;border-radius:9999px;background:#569D6F;color:#fff;font-weight:700;'+
      'line-height:1;white-space:nowrap;transform:rotate(-45deg);transform-origin:center;}'+
      '.rrx-discount-chip{display:inline-flex;align-items:center;gap:.35rem;padding:.1rem .5rem;border-radius:9999px;'+
      'border:1px solid currentColor;opacity:.8;font-weight:600;white-space:nowrap}'+
      '.rrx-price-hidden{display:none !important}'+
      '#rrx-cart-drawer [data-rrx-price],'+
      '#rrx-cart-drawer .rrx-price,'+
      '#rrx-cart-drawer .rrx-price *,'+
      '#rrx-cart-drawer .money,'+
      '#rrx-cart-drawer [data-price],'+
      '#rrx-cart-drawer .cart-item__price,'+
      '#rrx-cart-drawer .cart-item__totals,'+
      '#rrx-cart-drawer .rrx-amount,'+
      '#rrx-cart-drawer .rrx-price-now,'+
      '#rrx-cart-drawer .rrx-price-was,'+
      '#rrx-cart-drawer .rrx-price-was s{'+
        'color: var(--text-color, rgb(26,26,26)) !important;'+
        '-webkit-text-fill-color: currentColor !important;'+
        'opacity: 1 !important; filter: none !important; text-shadow: none !important;'+
      '}'+
      '#rrx-cart-drawer .rrx-discount-chip{color: var(--text-color, rgb(26,26,26)) !important;}';
    document.head.appendChild(st);
  }

  var MF = typeof Shopify !== "undefined" ? (window.Shopify.money_format || "") : "";
  function fmt(c){ try{ if(window.Shopify&&typeof Shopify.formatMoney==='function') return Shopify.formatMoney(c,MF);}catch(e){} return (c/100).toFixed(2)+' €'; }
  function fmtNoZeros(c){ var s=fmt(c); s=s.replace(/([.,])00(?!\d)/,''); s=s.replace(/([.,]\d)0(?!\d)/,'$1'); return s; }

  function getHost(){ return document.getElementById('CartDrawer')||document.querySelector('#rrx-cart-drawer, cart-drawer, .CartDrawer, .drawer--cart,[data-drawer="cart"]'); }
  function rootOf(n){ return (n && n.shadowRoot) ? n.shadowRoot : n; }

  function lineIsFree(it){
    var q=Number(it.quantity||1), uO=Number(it.original_price??it.price??0), uF=Number(it.final_price??it.discounted_price??it.price??0);
    var lO=Number(it.original_line_price ?? uO*q), lF=Number(it.final_line_price ?? uF*q);
    if(isNaN(lF)) lF=uF*q;
    if(Array.isArray(it.discounts)&&it.discounts.length){ var d=it.discounts.reduce((s,x)=>s+Number(x.amount||0),0); lF=Math.max(0,lO-d); }
    return lF===0;
  }

  function keyFromRow(row){
    var r=rootOf(row);
    var k=row.getAttribute('data-key')||row.dataset.key||r.querySelector('[data-key]')?.getAttribute?.('data-key');
    if(k) return k;
    var inp=r.querySelector('input[name^="updates["]'); 
    if(inp && inp.name){ var m=inp.name.match(/\[(.+?)\]/); if(m) return m[1]; }
    return null;
  }

  function findLineRows(host){
    var r=rootOf(host);
    var scope = r.querySelector('[data-cart-items], .cart-items, .rrx-cart-list, .Drawer__CartItems, .CartDrawer__Items, .cart-drawer__items') || r;
    return Array.from(scope.querySelectorAll('[data-cart-item],[data-line],[data-key],.cart-item,.rrx-line,.rrx-cart-line'))
      .filter(function(el){ return !el.closest('.cart-recommendations,[data-recommendations],.rrx-recos,.rrx-cross-sell,.rrx-upsell'); });
  }

  var PRICE_SEL = ['.rrx-price-current','.price-item--regular','.price-item','.money','[data-price]','.cart-item__price','.cart-item__totals','.rrx-amount','.rrx-item-price','.line-item__price','.product-option__price','.rrx-chip--price'].join(',');
  var TEXT_PRICE_RE = /(?:^|\s)[0-9]+(?:[.,]\d{1,2})?\s*€/;

  function hideOtherPrices(row, ui){
    var r = rootOf(row);
    r.querySelectorAll(PRICE_SEL).forEach(function(el){
      if (ui.contains(el) || el.closest('.rrx-free-ui')) return;
      el.classList.add('rrx-price-hidden');
    });
    Array.from(r.querySelectorAll('span,div,strong,b,small,ins,em')).forEach(function(el){
      if (ui.contains(el) || el.closest('.rrx-free-ui')) return;
      var t=(el.textContent||'').trim(); if (TEXT_PRICE_RE.test(t)) el.classList.add('rrx-price-hidden');
    });
  }
  function showPreviouslyHidden(row){
    var r = rootOf(row);
    r.querySelectorAll('.rrx-price-hidden').forEach(function(el){ el.classList.remove('rrx-price-hidden'); });
    r.querySelectorAll('.rrx-free-ui').forEach(function(n){ n.remove(); });
  }

  function applyFreeBadges(cart){
    var host=getHost(); if(!host||!cart||!Array.isArray(cart.items)) return;
    var rows=findLineRows(host); if(!rows.length) return;
    var map=new Map(cart.items.map(it=>[it.key,it]));

    rows.forEach(function(row){
      var r=rootOf(row), key=keyFromRow(row), item= key && map.get(key);
      if(!item) return;
      var free=lineIsFree(item);

      if(!free && row.__rrxFreeApplied){ row.__rrxFreeApplied=false; showPreviouslyHidden(row); return; }
      if(!free || row.__rrxFreeApplied) return;

      var priceWrap=r.querySelector('.rrx-line-price,.cart-item__price,.rrx-price,.price,[data-price],.cart-item__totals,.rrx-amount,.rrx-item-price') || r;

      var ui=document.createElement('span'); ui.className='rrx-free-ui';
      var tag=document.createElement('span'); tag.className='rrx-tag'; tag.textContent='Gratis';
      var old=document.createElement('span'); old.className='rrx-old';
      old.textContent=fmtNoZeros(Number(item.original_price??item.price??0));
      ui.append(tag,old);

      if(priceWrap.firstChild) priceWrap.insertBefore(ui, priceWrap.firstChild); else priceWrap.appendChild(ui);
      hideOtherPrices(row, ui);

      row.__rrxFreeApplied=true;
    });
  }

  (function(){
    var ID='rrx-free-tag-white';
    if (document.getElementById(ID)) return;
    var s=document.createElement('style'); s.id=ID;
    s.textContent = '#rrx-cart-drawer .rrx-free-ui .rrx-tag{ color: rgb(255,255,255) !important; -webkit-text-fill-color: rgb(255,255,255) !important; }';
    document.head.appendChild(s);
  })();

  function applySubtotalDiscount(cart){
    var host=getHost(); if(!host||!cart) return;
    var discount=0;
    if(typeof cart.original_total_price==='number'&&typeof cart.total_price==='number') discount=Math.max(0,cart.original_total_price-cart.total_price);
    if(!discount && typeof cart.total_discount==='number') discount=Math.max(discount,cart.total_discount);
    if(!discount && Array.isArray(cart.items)){
      discount=cart.items.reduce(function(s,it){
        var q=Number(it.quantity||1), o=Number(it.original_price??it.price??0)*q, f=Number(it.final_price??it.discounted_price??it.price??0)*q;
        if(Array.isArray(it.discounts)&&it.discounts.length){ var d=it.discounts.reduce((a,x)=>a+Number(x.amount||0),0); f=Math.max(0,o-d); }
        return s+Math.max(0,o-f);
      },0);
    }

    var r=rootOf(host);
    var explicit = r.querySelector('[data-rrx-savings]');
    if(explicit){ explicit.hidden=!(discount>0); if(discount>0) explicit.textContent='− '+fmtNoZeros(discount); return; }

    var subtotalEl  = r.querySelector('[data-rrx-subtotal]');
    var subtotalRow = subtotalEl 
      ? (subtotalEl.closest('.rrx-subtotal-row, .rrx-total-row, .cart__row, .totals, .cart-summary__row') || subtotalEl.parentElement)
      : (r.querySelector('.rrx-subtotal-row, cart-subtotal, [data-subtotal], .totals__subtotal, .cart__row--subtotal, .cart-summary__subtotal')
         || Array.from(r.querySelectorAll('*')).find(function(el){ return (el.textContent||'').toLowerCase().replace(/\s+/g,' ').includes('zwischensumme'); }));
    if(!subtotalRow) return;

    var chip=subtotalRow.querySelector('.rrx-discount-chip');
    if(!(discount>0)){ if(chip) chip.remove(); return; }
    if(!chip){ chip=document.createElement('span'); chip.className='rrx-discount-chip'; (subtotalRow.firstElementChild||subtotalRow).appendChild(chip); }
    chip.textContent='– '+fmtNoZeros(discount);
  }

  function applyAll(c){ try{ applyFreeBadges(c); applySubtotalDiscount(c); }catch(e){ console.warn('[RRX] applyAll',e); } }

  try{ Object.defineProperty(window,'LAST_CART',{ configurable:true,
    set:function(v){ window.__rrx_lastCart=v; applyAll(v); },
    get:function(){ return window.__rrx_lastCart||null; }
  }); }catch(_){}

  ;['cart:updated','cart:change','product:added','ajaxProduct:added','theme:cart:change','theme:cart:updated']
    .forEach(function(evt){ document.addEventListener(evt,function(e){ var c=(e&&e.detail&&e.detail.cart)||window.__rrx_lastCart||window.LAST_CART||null; if(c){ window.__rrx_lastCart=c; applyAll(c); } }); });

  function fetchCartOnce(){ try{ fetch('/cart.js',{credentials:'same-origin'}).then(r=>r.ok?r.json():null).then(c=>{ if(c){ window.__rrx_lastCart=c; applyAll(c); } }); }catch(e){} }
  document.addEventListener('DOMContentLoaded', fetchCartOnce);
  document.addEventListener('theme:drawer:open', fetchCartOnce);

  var host=getHost(); if(host){
    var timer=null; new MutationObserver(function(){
      if(timer) cancelAnimationFrame(timer);
      timer=requestAnimationFrame(function(){ var c=window.__rrx_lastCart||window.LAST_CART; if(c) applyAll(c); });
    }).observe(rootOf(host), {subtree:true,childList:true});
  }

  window.RRX_forceCartUI=function(){ var c=window.__rrx_lastCart||window.LAST_CART; if(c) applyAll(c); };
})();

  const META_PIXEL_BRIDGE_ENABLED = false;
  if (window.__RRX_CART_INIT__) return;
  window.__RRX_CART_INIT__ = true;

  const $  = (s) => document.querySelector(s);
  const $$ = (s) => Array.from(document.querySelectorAll(s));
  const drawer = $("#rrx-cart-drawer");
  if (!drawer) return;

  let overlay = $("#rrx-cart-overlay");
  if (!overlay) {
    overlay = document.createElement("div");
    overlay.id = "rrx-cart-overlay";
    overlay.hidden = true;
    document.body.appendChild(overlay);
  }

  const IN_EDITOR = !!(window.Shopify && Shopify.designMode);
  const MF        = typeof Shopify !== "undefined" ? (window.Shopify.money_format || "") : "";
  const CURRENCY  = "";
  /* ==========================================================================
   SPEEDSHOP ARCHITECT FIX: Dynamisches Shopify Markets Routing & Crash-Schutz
   ========================================================================== */
const getRoute = (path) => {
  // Prüft, ob das Routen-Objekt existiert (verhindert 'reading root' crash)
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
    ? window.Shopify.routes.root 
    : '/';
  // Baut die URL zusammen und verhindert doppelte Slashes (z.B. //cart.js)
  return (root + path).replace(/\/\//g, '/');
};

  const THRESHOLD = +(drawer.dataset.threshold || 0);
  const COUNTRY   = (drawer.dataset.country || "").toUpperCase();
  const VAT_MAP   = parseJSON(drawer.dataset.vatMap || "{}", {});
  const VAT       = (VAT_MAP[COUNTRY] ?? VAT_MAP.DEFAULT ?? 19);

  const FREEBAR_SUFFIX  = drawer.dataset.freebarSuffix || "";
  const FREEBAR_REACHED = drawer.dataset.freebarReached || "";

  const RECO_MAX  = 5;
  const QV_ENABLE = ((drawer.dataset.quick ?? "true") === "true");

  const MPX = (() => {
    const has = () => typeof window.fbq === "function";
    const id  = () => "rrx_" + Date.now().toString(36) + Math.random().toString(36).slice(2,8);
    const track = (name, payload={}) => {
      if (!has()) return;
      try { fbq("track", name, payload, { eventID: payload.eventID || id() }); } catch(_){}
    };
    return { track, id };
  })();

  function moneyFmt(cents){ try { return Shopify.formatMoney(cents, MF); } catch(_){ return (cents/100).toFixed(2).replace(".",",")+"\u00A0€"; } }
  function toCents(v){
    if (v == null) return 0;
    if (typeof v === "number") return (v < 50 && v % 1 !== 0) ? Math.round(v * 100) : Math.round(v);
    const s = String(v).replace(",", ".").trim();
    if (!s) return 0;
    return s.includes(".") ? Math.round(parseFloat(s) * 100) : Math.round(parseInt(s, 10) || 0);
  }

  function initExpressButtonsSafely(){
    try { if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === "function") { Shopify.PaymentButton.init(); } } catch(_) {}
  }
  function fixExpressVisibility(){
    const btnWrap = drawer.querySelector('.rrx-express .shopify-payment-button');
    if (!btnWrap) return;
    const hasAccelerated = !!btnWrap.querySelector('.shopify-payment-button__button');
    const more = btnWrap.querySelector('.shopify-payment-button__more-options');
    if (more) more.style.display = hasAccelerated ? 'none' : '';
  }

  let __rrxExpObserver = null;
  function ensureExpressObserver(){
    if (__rrxExpObserver) return;
    const exp = drawer.querySelector('.rrx-express');
    if (!exp) return;
    __rrxExpObserver = new MutationObserver(() => { initExpressButtonsSafely(); fixExpressVisibility(); });
    __rrxExpObserver.observe(exp, { childList: true, subtree: true });
  }

  function parseJSON(s, fb={}){ try{ return JSON.parse(s); } catch(_){ return fb; } }
  /* 🚨 SPEEDSHOP FIX: Automatisches WebP & Quality 85 für alle dynamischen JS-Bilder erzwingen */
  function imgUrl(u, w){
    if (!u) return "";
    const src = (typeof u === "string") ? u : (u.url || u.src || u.original_src || (u.image && (u.image.src || u.image.url)) || "");
    if (!src) return "";
    try {
      const url = new URL(src, location.origin);
      if (w) url.searchParams.set("width", String(w));
      url.searchParams.set("format", "webp");
      url.searchParams.set("quality", "85");
      return url.toString();
    } catch(_) {
      const s = String(src);
      if (!w) return s;
      const sep = s.includes("?") ? "&" : "?";
      return s + sep + `width=${w}&format=webp&quality=85`;
    }
  }

  function byId(id){ return document.getElementById(id); }
  function dl(event, params={}){ window.dataLayer = window.dataLayer || []; window.dataLayer.push({event, ...params}); }
  function extractHandleFromUrl(u){ const m=String(u||"").match(/\/products\/([^\/?#]+)/); return m ? m[1] : ""; }
  const handleize = (s)=> String(s||"").trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/[^a-z0-9]+/g,"-").replace(/(^-|-$)/g,"");
  const titleizeHandle = (h)=> h.split("-").map(w=>w? w[0].toUpperCase()+w.slice(1) : w).join("-");
  const cdnFile = (name)=> name.startsWith("http") || name.startsWith("/") ? name : `/cdn/shop/files/${encodeURIComponent(name)}`;

  let LAST_CART = null;

  /* ==========================================================================
     SPEEDSHOP ARCHITECT FIX: A11y Focus Trap & Inert Support
     ========================================================================== */
  function openDrawer(){
    // Macht den Drawer für Screenreader und Tab-Fokus zugänglich
    drawer.removeAttribute("inert"); 
    drawer.setAttribute("aria-hidden","false");
    overlay.hidden = false;
    document.documentElement.classList.add("rrx-cart-open");
    const closeBtn = drawer.querySelector(".rrx-close");
    if (closeBtn) setTimeout(() => closeBtn.focus(), 100);
    initExpressButtonsSafely();
    requestAnimationFrame(() => { initExpressButtonsSafely(); fixExpressVisibility(); });
  }

  function closeDrawer(){
    // SPEEDSHOP FIX: Zwingt den Browser, den Fokus vom Schließen-Button zu nehmen, 
    // BEVOR aria-hidden gesetzt wird. Verhindert den Lighthouse/Console Crash.
    if (document.activeElement && drawer.contains(document.activeElement)) {
      document.activeElement.blur();
    }
    
    drawer.setAttribute("aria-hidden","true");
    // Blockiert alle Klicks und Tab-Fokus Events im versteckten Zustand hart
    drawer.setAttribute("inert", ""); 
    overlay.hidden = true;
    document.documentElement.classList.remove("rrx-cart-open");
    dl("rrx_cart_drawer_close");
  }

  window.RRXCartDrawer = { open: openDrawer, close: closeDrawer, refresh };
// --- NEU: ERFOLGS-BANNER LOGIK ---
  if (!document.getElementById("rrx-success-banner-css")) {
    const bCss = document.createElement("style");
    bCss.id = "rrx-success-banner-css";
    bCss.textContent = `
      /* Versteckt die rechte Überschrift komplett */
      #rrx-cart-drawer .rrx-right-h3 {
        display: none !important;
      }

     .rrx-left-header-wrap { 
        display: flex !important; 
        flex-direction: row !important;
        align-items: center !important; /* Zwingt alles auf die absolute mathematische Mitte */
        width: 100%;
        margin-bottom: 24px !important; /* NEU: Sichtbar mehr Abstand zur ersten Kachel */
      }
      #rrx-cart-drawer .rrx-left-h3 { 
        margin: 0 !important; 
        padding: 0 !important;
        white-space: nowrap; 
        line-height: 1 !important; /* Stoppt das unsichtbare Theme-Padding der Schrift */
        display: block !important;
      }
      .rrx-success-banner { 
        display: flex !important; 
        align-items: center !important; 
        justify-content: center !important;
        gap: 6px; 
        background: rgba(74, 93, 83, 0.08); 
        border: 1px solid rgba(74, 93, 83, 0.15); 
        color: var(--hdc, #2f2f2f); 
        padding: 5px 12px; 
        border-radius: 10px; 
        font-size: 13px; 
        font-weight: 700; 
        opacity: 0; 
        transform: scale(0.95); 
        transition: opacity 0.25s ease, transform 0.25s ease; 
        pointer-events: none; 
        visibility: hidden; 
        box-shadow: 0 2px 8px rgba(0,0,0,0.03); 
        line-height: 1 !important; 
        margin: 0 auto !important; /* Holt sich den gesamten Restplatz und zentriert sich darin */
      }
      .rrx-success-banner.is-active { 
        opacity: 1; 
        transform: scale(1); 
        visibility: visible; 
      }
      .rrx-success-banner svg { 
        width: 16px; 
        height: 16px; 
        flex-shrink: 0; 
        display: block !important; /* Tötet den unsichtbaren Abstand, den SVGs oft verursachen */
      }
      .rrx-banner-text {
        display: block !important;
        line-height: 1 !important;
        transform: translateY(1px); /* Typografische Feinjustierung für die Großbuchstaben */
      }
      
      @media (max-width: 480px) { 
        .rrx-success-banner { 
          font-size: 12px; 
          padding: 5px 10px; 
        } 
      }
    `;
    document.head.appendChild(bCss);
  }

  // Das Array mit deinen dynamischen Sprüchen
  window.__rrxBannerTexts = [
    "Passt perfekt!",
    "Gute Wahl!",
    "Tolle Auswahl!",
    "Sehr schön!",
    "Perfekt ergänzt!"
  ];
  
  // Start-Index
  if (typeof window.__rrxBannerIndex === "undefined") {
    window.__rrxBannerIndex = 0;
  }

  window.RRXShowSuccessBanner = function() {
    let banner = document.getElementById('rrx-success-banner');
    const drawerNode = document.getElementById('rrx-cart-drawer');
    const scrollContainer = document.querySelector('#rrx-cart-drawer .rrx-view[data-view="cart"]');
    
    // Container und Banner bauen, falls nicht vorhanden
    if (!banner) {
      const h3 = document.querySelector('#rrx-cart-drawer .rrx-left-h3');
      if (h3) {
        const wrapper = document.createElement('div');
        wrapper.className = 'rrx-left-header-wrap';
        h3.parentNode.insertBefore(wrapper, h3);
        wrapper.appendChild(h3);
        
        banner = document.createElement('div');
        banner.id = 'rrx-success-banner';
        banner.className = 'rrx-success-banner';
        wrapper.appendChild(banner);
        
        if (drawerNode) {
          // 1. Observer: Blendet Banner aus, wenn der gesamte Warenkorb geschlossen wird
          new MutationObserver((mutations) => {
            mutations.forEach(m => {
              if (m.attributeName === 'aria-hidden' && drawerNode.getAttribute('aria-hidden') === 'true') {
                banner.classList.remove('is-active');
              }
            });
          }).observe(drawerNode, { attributes: true });

          // 2. Scroll-Observer: Blendet Banner aus, wenn der User nach unten scrollt und der Banner das Sichtfeld verlässt
          if (scrollContainer) {
            const io = new IntersectionObserver((entries) => {
              entries.forEach(entry => {
                // Wenn das Element den sichtbaren Bereich verlässt UND aktuell aktiv ist
                if (!entry.isIntersecting && banner.classList.contains('is-active')) {
                  banner.classList.remove('is-active');
                }
              });
            }, { root: scrollContainer, threshold: 0 }); // threshold: 0 bedeutet: sobald der letzte Pixel verschwindet
            
            io.observe(banner);
          }
        }
      }
    }
    
    // Banner einblenden und dynamischen Text setzen
    if (banner) {
      // Aktuellen Spruch laden
      const currentText = window.__rrxBannerTexts[window.__rrxBannerIndex];
      
      // Icon (Grüner Kreis in Cart-Farbe + Weißer Haken) und neuer Text
      banner.innerHTML = `
        <svg viewBox="0 0 24 24" fill="var(--ac, #2E7D32)">
          <circle cx="12" cy="12" r="12"/>
          <path d="M7 12.5l3 3 7-7" fill="none" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg> 
        <span class="rrx-banner-text">${currentText}</span>
      `;
      
      // Index für den nächsten Klick erhöhen (fängt nach dem letzten Spruch wieder bei 0 an)
      window.__rrxBannerIndex = (window.__rrxBannerIndex + 1) % window.__rrxBannerTexts.length;

      banner.classList.remove('is-active');
      void banner.offsetWidth; // Reflow erzwingen
      banner.classList.add('is-active');
    }
  };

  overlay.addEventListener("click", closeDrawer);
  drawer.querySelector(".rrx-close")?.addEventListener("click", closeDrawer);

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    const z = byId("rrx-qv-zoom");
    if (z && z.getAttribute("aria-hidden")==="false"){ closeZoom(); return; }
    const qv = byId("rrx-qv");
    if (qv && qv.getAttribute("aria-hidden")==="false"){ closeQuickView(); return; }
    closeDrawer();
  });

  $("#rrx-hidden-cart-opener")?.addEventListener("click", (e) => { e.preventDefault(); openDrawer(); refresh(true); });

  const tabs  = drawer.querySelectorAll("[data-tab]");
  const views = Array.from(drawer.querySelectorAll(".rrx-view"));
  const VALID = new Set(views.map(v => (v.dataset.view||"").toLowerCase()));
  const ALIAS = { overview:"cart","übersicht":"cart",uebersicht:"cart",items:"cart",cart:"cart",recent:"recent",angesehen:"recent" };
  const norm  = (n)=>{ const k=(n||"").toLowerCase(); const m=ALIAS[k]||k; return VALID.has(m) ? m : (views[0]?.dataset.view||""); };
  
  function showView(which){
    const t = norm(which);
    views.forEach(v => v.hidden = ((v.dataset.view||"").toLowerCase() !== t));
    tabs.forEach(b => b.classList.toggle("rrx-tab--active", norm(b.dataset.tab)===t));
    dl("rrx_tab_switch",{tab:t});
    if (t==="recent") renderRecent();
  }
  tabs.forEach(btn => btn.addEventListener("click",(e)=>{ e.preventDefault(); showView(btn.dataset.tab); }));
  if (location.hash) showView(location.hash.slice(1));
  else showView(views.find(v=>!v.hidden)?.dataset.view || views[0]?.dataset.view);

  /* Theme Drawer kill */
  (function injectKillCss(){
    const KILL_SELECTORS = ['#cart-drawer', '.cart-drawer', '.drawer--cart', '.CartDrawer', '.cart__drawer', '.MiniCart', '.mini-cart', '.js-mini-cart', '.drawer[data-drawer-id="cart"]', '.drawer[data-drawer="cart"]', '#CartDrawer', '.header__icon--cart + .drawer', 'cart-notification', 'cart-notification-drawer', '#CartNotification', '.cart-notification', '#cart-notification'];
    let style = document.getElementById('rrx-kill-theme-cart-css');
    if (!style){ style = document.createElement('style'); style.id='rrx-kill-theme-cart-css'; document.head.appendChild(style); }
    style.textContent = `${KILL_SELECTORS.join(',')} { display: none !important; }`;
  })();

  const TRIGGERS_SEL = ['[aria-controls="cart-drawer"]', '[aria-controls="CartDrawer"]', '[data-drawer="cart"]','[data-cart-open]','#cart-icon-bubble', '.header__icon--cart','.header__cart','.cart-toggle','a[href="/cart"]','a[href^="/cart"]', 'a[href="#cart"]','.js-drawer-open-cart','.open-cart','button[name="cart"]', '[data-action="open-drawer"][data-drawer-id="cart"]'].join(',');
  
  function shouldIntercept(e){
    const isBot = /googlebot|storebot|google-adwords-display-ads-bot|adsbot-google|bingbot|duckduckbot/i.test(navigator.userAgent);
    if (isBot) return false; 
    const t = e.target;
    if (!t || !t.closest) return false;
    if (t.closest("#rrx-cart-drawer")) return false; 
    return !!t.closest(TRIGGERS_SEL);
  }
  
  function intercept(e){
    if (!shouldIntercept(e)) return;
    e.preventDefault(); e.stopPropagation(); try{ e.stopImmediatePropagation(); }catch(_){}
    openDrawer(); refresh(true); dl("rrx_cart_trigger_intercepted",{source:"any"});
  }
  
  if (!IN_EDITOR) { document.addEventListener('click', intercept, {capture: true}); }

  (function routeToastCtasToDrawer(){
    const TOAST_HOST_SEL = 'cart-notification, cart-notification-drawer, #CartNotification, .cart-notification';
    function isToastHost(el){ return !!(el?.matches && el.matches(TOAST_HOST_SEL)); }
    function hasRRX(){ return !!(window.RRXCartDrawer && typeof window.RRXCartDrawer.open === 'function'); }

    function handle(e){
      if (!hasRRX()) return;
      const path = (typeof e.composedPath === 'function') ? e.composedPath() : [];
      let inToast = false, hit = null, host = null;

      for (const node of path){
        if (!node || node.nodeType !== 1) continue;
        if (!inToast && isToastHost(node)) { inToast = true; host = node; }
        if (!hit && node.matches?.('a[href*="/cart"], [name="checkout"], .cart-notification__checkout')) { hit = node; }
      }
      if (!inToast || !hit) return;

      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation?.();
      if (host) host.style.display = 'none';

      try{ window.RRXCartDrawer.open(); window.RRXCartDrawer.refresh(true); }catch(_){}
    }

    document.addEventListener('click', handle, true);
    document.addEventListener('submit', (e)=>{
      const path = e.composedPath ? e.composedPath() : [];
      if (path.some(n => n?.matches?.(TOAST_HOST_SEL))) handle(e);
    }, true);
  })();

(function interceptAddToCartForms(){
    let isAdding = false;

    document.addEventListener('submit', function(e){
      const form = e.target && e.target.closest ? e.target.closest('form') : null;
      if (!form) return;

      const isAddForm = /\/cart\/add/i.test(form.action || '') || form.querySelector('[name="add"]');
      if (!isAddForm) return;

      if (form.closest('#rrx-cart-drawer') || form.closest('#rrx-qv')) return;

      e.preventDefault();
      e.stopPropagation();
      try { e.stopImmediatePropagation(); } catch(_) {}

      if (isAdding) return;
      isAdding = true;

      const submitBtn = form.querySelector('[type="submit"], [name="add"], .add-to-cart');
      if (submitBtn) {
          submitBtn.setAttribute('disabled', 'disabled');
          submitBtn.style.opacity = '0.6';
          submitBtn.style.cursor = 'wait';
      }

      // Daten aus dem Formular holen
      const fd = new FormData(form);
      const vid = fd.get('id') || fd.get('variant') || fd.get('variant_id');
      const qty = Number(fd.get('quantity') || 1) || 1;

      // Eventuelle "Properties" (z.B. Gravuren, Personalisierung) aus dem Formular retten
      let properties = {};
      for (let [key, value] of fd.entries()) {
        if (key.includes('properties[')) {
          let propName = key.match(/\[(.*?)\]/)[1];
          if (propName) properties[propName] = value;
        }
      }

      // Custom Tracking feuern
      try {
        window.RRXFireATCOnce?.({ id: vid, quantity: qty });
      } catch (_) {}

      // Das Payload als sauberes JSON aufbauen
      const payload = {
        id: vid,
        quantity: qty
      };
      if (Object.keys(properties).length > 0) {
        payload.properties = properties;
      }

      // 🚨 SRE FIX: Harte Zuweisung für reguläre Käufe
      window._sre_active_ajax_list = "Direkt über Produktseite";

      // SpeedShop Fix: AJAX Fetch mit lokalisierter Route
      fetch(getRoute('cart/add.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // WICHTIG: Sagt Shopify & Pixel, dass JSON kommt
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      .then(response => response.json())
      .then(() => {
        if (typeof window.RRXCartDrawer !== 'undefined') {
          window.RRXCartDrawer.refresh(false);
          window.RRXCartDrawer.open();
        }
        if (typeof window.RRXShowSuccessBanner === "function") {
           window.RRXShowSuccessBanner();
        }
      })
      .catch((err) => {
        console.error('[RRX] Fehler beim Hinzufügen:', err);
      })
      .finally(() => {
        isAdding = false;
        if (submitBtn) {
            submitBtn.removeAttribute('disabled');
            submitBtn.style.opacity = '1';
            submitBtn.style.cursor = 'pointer';
        }
      });
    }, true);
  })();

  // SpeedShop Fix: Dynamische Route für Markets
  async function getCart(){ try { return await fetch(getRoute("cart.js"),{credentials:"same-origin"}).then(r=>r.json()); } catch(_){ return {items:[], item_count:0, total_price:0}; } }
  function mapItems(cart){
    return (cart.items||[]).slice(0,10).map(it=>({
      item_id:String(it.variant_id||it.product_id||it.id),
      item_name:it.product_title, item_variant:it.variant_title||"",
      item_brand:it.vendor||"", price:(it.price||0)/100, quantity:it.quantity||0
    }));
  }

  const VCP_CACHE = new Map();
  async function getVariantCompareCents(variantId){
    if (!variantId) return 0;
    if (VCP_CACHE.has(variantId)) return VCP_CACHE.get(variantId);
    try{
      const res = await fetch(getRoute(`variants/${variantId}.js`), { credentials:"same-origin" });
      const v = await res.json();
      const c = Number(v?.compare_at_price) || 0; 
      VCP_CACHE.set(variantId, c);
      return c;
    } catch(_){
      VCP_CACHE.set(variantId, 0);
      return 0;
    }
  }

  function priceHTML(wasCents, nowCents){
    if ((wasCents||0) > (nowCents||0)){
      return `<span class="rrx-price-was" aria-hidden="true"><s>${moneyFmt(wasCents)}</s></span><span class="rrx-price-now">${moneyFmt(nowCents)}</span>`;
    }
    return `<span class="rrx-price-now">${moneyFmt(nowCents||0)}</span>`;
  }

  async function computeCartSavings(cart){
    let total = 0;
    for (const it of (cart.items||[])){
      const qty     = it.quantity||1;
      const nowLine = it.final_line_price || it.line_price || ((it.price||0)*qty);

      let wasUnit = it.original_price || it.price || 0; 
      const cap   = await getVariantCompareCents(it.variant_id); 
      if (cap > wasUnit) wasUnit = cap;

      const wasLine = wasUnit * qty;
      const diff    = Math.max(0, wasLine - nowLine);
      total += diff;
    }
    return total; 
  }

  function renderItems(cart){
    const wrap = drawer.querySelector("[data-rrx-items]");
    if (!wrap) return;

    // --- QTY UI ENHANCEMENTS (Versteckt native Pfeile & fügt Hover hinzu) ---
    if (!document.getElementById("rrx-qty-enhancements-css")) {
      const st = document.createElement("style");
      st.id = "rrx-qty-enhancements-css";
      st.textContent = `
        /* Native Pfeile in Chrome/Safari/Edge eliminieren */
        #rrx-cart-drawer .rrx-custom-qty input[type="number"]::-webkit-inner-spin-button,
        #rrx-cart-drawer .rrx-custom-qty input[type="number"]::-webkit-outer-spin-button {
          -webkit-appearance: none; margin: 0;
        }
        /* Native Pfeile in Firefox eliminieren */
        #rrx-cart-drawer .rrx-custom-qty input[type="number"] {
          -moz-appearance: textfield;
        }
        /* Hover-Effekt für die neuen Pfeile */
        #rrx-cart-drawer .rrx-qty-btn {
          transition: background-color 0.2s ease;
        }
        #rrx-cart-drawer .rrx-qty-btn:hover {
          background-color: #eef0f2 !important;
        }
      `;
      document.head.appendChild(st);
    }

// --- LIVE STERNE ENGINE (Holt Loox-Daten im Hintergrund) ---
    if (!document.getElementById("rrx-loox-stars-css")) {
      const st = document.createElement("style");
      st.id = "rrx-loox-stars-css";
      st.textContent = `
        /* Sterne unten rechts platzieren */
        .rrx-rating-wrapper {
          position: absolute; right: 8px; bottom: 8px; z-index: 5; display: flex; flex-direction: column; align-items: center; gap: 4px; cursor: pointer; transition: transform 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }
        .rrx-rating-wrapper:hover { transform: scale(1.05); }
        .rrx-rating-bubble {
          background: rgba(255, 255, 255, 0.9); box-shadow: 0 2px 4px rgba(0,0,0,0.12); backdrop-filter: blur(2px); border-radius: 12px;
        }
        .rrx-bubble-stars { padding: 6px 4px; display: flex; flex-direction: column-reverse; gap: 2px; }
        .rrx-bubble-count { padding: 2px 5px; min-width: 20px; text-align: center; }
        .rrx-review-count-text { font-size: 9px; font-weight: 700; line-height: 1; color: #2D3631; display: block; }
        .rrx-star-wrapper { position: relative; width: 10px; height: 10px; display: block; pointer-events: none; }
        .rrx-custom-star-icon { width: 10px; height: 10px; display: block; }
        .rrx-custom-star-filled { color: #FFC107 !important; fill: #FFC107 !important; }
        
        /* Etwas größere Darstellung für Desktop */
        @media screen and (min-width: 1000px) {
          .rrx-rating-wrapper { right: 12px; bottom: 12px; gap: 5px; }
          .rrx-bubble-stars { padding: 10px 6px; gap: 4px; }
          .rrx-bubble-count { padding: 3px 8px; min-width: 24px; }
          .rrx-star-wrapper, .rrx-custom-star-icon { width: 16px; height: 16px; }
          .rrx-review-count-text { font-size: 12px; }
        }
      `;
      document.head.appendChild(st);
    }

    if (!Array.isArray(cart.items) || cart.items.length === 0) {
      wrap.innerHTML = '<div class="rrx-empty-cols" data-rrx-empty-cols></div>';
      renderEmptyCollections();
      return;
    }

    wrap.innerHTML = "";

    (cart.items || []).forEach(it => {
      const el = document.createElement("div");
      el.className = "rrx-item";

      el.dataset.handle       = it.handle || "";
      el.dataset.url          = it.url || "";
      el.dataset.key          = it.key;
      el.dataset.variantId    = it.variant_id || "";
      el.dataset.productId    = it.product_id || "";
      el.dataset.vendor       = it.vendor || "";
      el.dataset.title        = it.product_title || "";
      el.dataset.variantTitle = it.variant_title || "";
      el.dataset.unitPrice    = (it.price || 0);

      const src = imgUrl(it.image || (it.featured_image && (it.featured_image.url || it.featured_image)) || "", 160);

      const variantTitleFormatted = (it.variant_title || "").replace(/\s*\/\s*/g, " | ");

      
      el.innerHTML = `
        <img src="${src}" alt="" loading="lazy" decoding="async" style="grid-column: 1; grid-row: 1 / span 2; align-self: center; cursor: pointer; transition: opacity 0.2s;" onmouseover="this.style.opacity='0.8'" onmouseout="this.style.opacity='1'" data-act="open-qv"> 
        <div style="grid-column: 2; grid-row: 1 / span 2; display: flex; flex-direction: column; justify-content: center; gap: 4px; cursor: pointer;" class="rrx-item-click" data-act="open-qv">
          <p class="rrx-item-title" style="margin: 0; grid-column: unset; grid-row: unset;">${it.product_title || ""}</p>
          <p class="rrx-item-meta" style="margin: 0; grid-column: unset; grid-row: unset; color: var(--hdc, #2f2f2f);">${variantTitleFormatted}</p>
          <div class="rrx-price" data-rrx-price style="margin: 2px 0 0 0; grid-column: unset; grid-row: unset; justify-self: start; align-self: start; font-size: 14px;">–</div>
        </div>

        <div style="grid-column: 3; grid-row: 1 / span 2; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;">
          
          <div class="rrx-custom-qty" style="position: relative; width: 78px; height: 42px; border: 1px solid #e3e6ea; border-radius: 6px; background: #f9fafb; overflow: hidden; display: flex;">
            <input type="number" min="1" step="1" value="${it.quantity}" aria-label="Aktuelle Menge" style="box-sizing: border-box; width: 48px !important; height: 100%; text-align: center; border: none !important; font-weight: 600; font-size: 15px; background: transparent !important; color: var(--hdc, #2f2f2f) !important; margin: 0; padding: 0 0 0 4px; outline: none; box-shadow: none;">
            
            <div style="display: flex; flex-direction: column; width: 30px; border-left: 1px solid #e3e6ea; background: #ffffff;">
              <button type="button" data-act="inc" class="rrx-qty-btn" style="flex: 1; display: flex; align-items: center; justify-content: center; background: transparent; border: none; border-bottom: 1px solid #e3e6ea; padding: 0; cursor: pointer; color: var(--hdc, #2f2f2f);">
                <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>
              </button>
              <button type="button" data-act="dec" class="rrx-qty-btn" style="flex: 1; display: flex; align-items: center; justify-content: center; background: transparent; border: none; padding: 0; cursor: pointer; color: var(--hdc, #2f2f2f);">
                <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
              </button>
            </div>
          </div>

          <button type="button" data-act="remove" class="rrx-remove-txt-btn" style="background: none !important; border: none !important; padding: 0 !important; font-size: 13px !important; text-decoration: underline !important; color: var(--text-color, #4A5D53) !important; cursor: pointer; transition: all 0.2s ease;">Entfernen</button>
        </div>
      `;
      wrap.appendChild(el);
      
      {
        const priceEl = el.querySelector("[data-rrx-price]");
        const nowUnit = it.final_price || it.price || 0;
        let   wasUnit = it.original_price || it.price || 0;

        priceEl.innerHTML = priceHTML(wasUnit, nowUnit);
        getVariantCompareCents(it.variant_id).then(cap => {
          if (cap > wasUnit && cap > nowUnit){
            priceEl.innerHTML = priceHTML(cap, nowUnit);
          }
        });
      }
    });

    wrap.querySelectorAll(".rrx-item").forEach(row => {
      const key    = row.dataset.key;
      const handle = row.dataset.handle;
      const input  = row.querySelector("input");

      const base = {
        item_id: row.dataset.variantId || row.dataset.productId || key,
        item_name: row.dataset.title, item_variant: row.dataset.variantTitle,
        item_brand: row.dataset.vendor, price: (+row.dataset.unitPrice || 0) / 100
      };

      const fire = (type, qty) => {
        const item = { ...base, quantity: Math.abs(qty) };
        if (type === "remove") { dl("remove_from_cart", { currency: CURRENCY, value: item.price * item.quantity, items: [item] }); }
        if (type === "add") {
          try { window.RRXFireATCOnce?.({ id: base.item_id, quantity: qty }); } catch(_){}
          try {
            if (typeof META_PIXEL_BRIDGE_ENABLED !== 'undefined' && META_PIXEL_BRIDGE_ENABLED) {
              MPX.track("AddToCart", { content_ids: [String(base.item_id)], content_type: 'product', value: item.price * item.quantity, currency: CURRENCY });
            }
          } catch (_) {}
          
          // 🚨 SRE FIX: Sende Klicks auf das "+" im Drawer sicher an die SRE GA4 Sandbox!
          try {
            if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
              window.Shopify.analytics.publish('custom_sre_ajax_cart', { 
                cartData: { 
                  id: String(base.item_id).split('_').pop(), 
                  product_title: base.item_name, // <-- Isoliert den Basisnamen!
                  variant_title: base.item_variant,
                  price: Math.round((base.price || 0) * 100), 
                  quantity: Math.abs(qty),
                  attributes: { _sre_list_name: "Cart Drawer (+ Button)" }
                }
              });
            }
          } catch (e) {}
        }
      };

      // Quick-View Logik
      const qvTriggers = row.querySelectorAll('[data-act="open-qv"]');
      qvTriggers.forEach(t => {
        t.addEventListener('click', (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          
          if (typeof openQuickView === "function" && typeof QV_CACHE !== "undefined") {
            if (!QV_CACHE.has(handle) && typeof preloadQV === "function") preloadQV(handle);
            
            QV_CACHE.get(handle).then(p => {
              openQuickView(p);
              setTimeout(() => {
                const qv = document.getElementById("rrx-qv");
                if (!qv) return;
                const addBtn = qv.querySelector("[data-qv-add]");
                
                if (addBtn && !qv.querySelector('.qv-to-product-link')) {
                  const linkBtn = document.createElement("a");
                  linkBtn.className = "qv-to-product-link";
                  linkBtn.href = `/products/${handle}`;
                  linkBtn.innerText = "Zur Produktseite";
                  linkBtn.style.display = "block";
                  linkBtn.style.marginTop = "12px";
                  linkBtn.style.fontSize = "14px";
                  linkBtn.style.fontWeight = "600";
                  linkBtn.style.textDecoration = "underline";
                  linkBtn.style.color = "var(--text-color, #4A5D53)";
                  linkBtn.style.cursor = "pointer";
                  
                  addBtn.parentNode.insertBefore(linkBtn, addBtn.nextSibling);
                }
              }, 10);
            }).catch(() => {
              window.location.href = `/products/${handle}`;
            });
          } else {
            window.location.href = `/products/${handle}`;
          }
        });
      });

      // Logik für die neuen Hoch/Runter-Pfeile
      const incBtn = row.querySelector("[data-act='inc']");
      if(incBtn) {
        incBtn.addEventListener("click", () => { 
          row.style.opacity = "0.4";
          row.style.pointerEvents = "none";
          fire("add", 1); 
          updateQty(key, +input.value + 1); 
        });
      }

      const decBtn = row.querySelector("[data-act='dec']");
      if(decBtn) {
        decBtn.addEventListener("click", () => { 
          row.style.opacity = "0.4";
          row.style.pointerEvents = "none";
          const nv = +input.value - 1;
          fire("remove", 1); 
          updateQty(key, Math.max(0, nv)); 
        });
      }

      // Logik für restloses Entfernen
      const removeBtn = row.querySelector("[data-act='remove']");
      if(removeBtn) {
        removeBtn.addEventListener("click", () => { 
          row.style.opacity = "0.4";
          row.style.pointerEvents = "none";
          fire("remove", +input.value); 
          updateQty(key, 0); 
        });
      }

      // Logik für direkte Zahleneingabe über die Tastatur
      input.addEventListener("change", (e) => {
        let nv = +e.target.value; 
        
        if (nv <= 0) {
           row.style.opacity = "0.4";
           row.style.pointerEvents = "none";
           fire("remove", +(e.target.getAttribute("value") || 1)); 
           updateQty(key, 0);
           return;
        }

        const ov = +(e.target.getAttribute("value") || 0);
        const diff = nv - ov;
        if (diff > 0) fire("add", diff);
        if (diff < 0) fire("remove", -diff);
        e.target.setAttribute("value", String(nv));
        updateQty(key, nv);
      });
    });
  }

  function renderEmptyCollections(){
    const holder = drawer.querySelector('[data-rrx-empty-cols]');
    if(!holder) return;

    let cols = [];
    try { cols = JSON.parse(drawer.dataset.emptyCols || "[]"); } catch(_){}
    if(!Array.isArray(cols) || cols.length === 0){ holder.remove(); return; }

    holder.innerHTML = "";
    cols.slice(0,3).forEach((c, i) => {
      const handle = c?.handle || ""; const title  = c?.title  || handle.replace(/-/g, " "); const img    = c?.image  || "";
      const a = document.createElement("a");
      a.className = "ec-card"; a.href = handle ? (`/collections/${handle}`) : "#"; a.style.setProperty("--i", String(i));
      a.innerHTML = `<div class="ec-media">${ img ? `<img src="${img}" alt="" loading="lazy" decoding="async">` : `<div class="ec-ph"></div>` }</div><div class="ec-body"><div class="ec-title">${title}</div><div class="ec-cta">Jetzt entdecken</div></div>`;const imgEl = a.querySelector("img");
      if (imgEl) { imgEl.addEventListener("error", () => { a.querySelector(".ec-media").innerHTML = '<div class="ec-ph"></div>'; }, { once:true }); }
      holder.appendChild(a);
    });
  }

  // SpeedShop Fix: Sicherer Quantity-Update inkl. Markets-Support
  async function updateQty(key, qty){
    qty = Math.max(0, qty);
    await fetch(getRoute("cart/change.js"), { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({id:key, quantity:qty}) });
    refresh(false);
  }

  async function estimateShippingCents(subtotalCents){
    if (THRESHOLD > 0 && subtotalCents >= THRESHOLD) return 0;
    const flat = parseFloat(drawer.dataset.ship||"0")||0;
    return Math.round(flat*100);
  }

  async function renderTotals(cart){
    const subtotal = cart.total_price || 0; 
    drawer.querySelector("[data-rrx-subtotal]").textContent = moneyFmt(subtotal);
    
    {
      const badge = drawer.querySelector("[data-rrx-savings]");
      if (badge){
        badge.hidden = true;
        computeCartSavings(cart).then(sav => {
          if (sav > 0){ badge.textContent = "−" + moneyFmt(sav); badge.hidden = false; }
        });
      }
    }

    const shippingCents = (cart.item_count||0) === 0 ? 0 : await estimateShippingCents(subtotal);
    const shipEl = drawer.querySelector("[data-rrx-shipping]");
    shipEl.innerHTML = (shippingCents===0) ? `<span class="rrx-free-inline">${drawer.dataset.freeText||"Gratis Versand!"}</span>` : moneyFmt(shippingCents);

    const grand = subtotal + (shippingCents||0);
    drawer.querySelector("[data-rrx-total]").textContent = moneyFmt(grand);

    const taxEl = drawer.querySelector(".rrx-taxnote");
    if (taxEl){
      const tpl = taxEl.getAttribute("data-tax-note") || taxEl.textContent || "";
      taxEl.textContent = tpl.replace("{vat}", String(VAT).replace(".",","));
    }

    const fill = drawer.querySelector(".rrx-freebar-fill");
    const knob = drawer.querySelector(".rrx-freebar-knob");
    const remainEl = drawer.querySelector(".rrx-remain");
    if (THRESHOLD > 0 && fill && knob && remainEl){
      const p = Math.min(100, Math.round(subtotal*100/THRESHOLD));
      fill.style.width = p + "%";
      knob.style.left  = p + "%";
      const remain = Math.max(0, THRESHOLD - subtotal);
      const reached = remain <= 0;
      remainEl.textContent = reached ? "0,00 €" : moneyFmt(remain);

      const preEl  = drawer.querySelector(".rrx-pre");
      const postEl = drawer.querySelector(".rrx-post");
      if (preEl && postEl){
        if (FREEBAR_SUFFIX || FREEBAR_REACHED) { postEl.textContent = reached ? (FREEBAR_REACHED || postEl.textContent) : (FREEBAR_SUFFIX || postEl.textContent); }
        preEl.style.display = reached ? "none" : "";
      }
    }
  }

  // SPEEDSHOP ARCHITECT: Das ultimative Stanley/Stella Color-Dictionary v2
  // Beinhaltet Core-, Seasonal- und Heather-Farben zur 100% Vermeidung des #ddd Fallbacks.
  const COLOR_HEX = {
    /* Basics & Monochromes */
    weiss:"#ffffff", "weiß":"#ffffff", white:"#ffffff", "sport white":"#f4f5f7", "off white":"#f8f8f8", "vintage white":"#f0ede4",
    schwarz:"#000000", black:"#000000", "panther black":"#242526", "pure black":"#0a0a0a",
    grau:"#9aa3ab", gray:"#9aa3ab", grey:"#9aa3ab", anthracite:"#424446",charcoal:"#675f58",
    
    /* Heathers & Melanges */
    "heather grey":"#dcdcdc", "dark heather grey":"#404245", "mid heather grey":"#a4a6a8", "cream heather grey":"#e6e2d6", "cool heather grey":"#b6b9bd",
    "dark heather blue":"#2a3546", "mid heather blue":"#6f7f9b", "heather denim":"#4f6076",
    "mid heather khaki":"#9b9a7a", "cream heather pink":"#ead7d2", "slub heather grey":"#b4b4b4", "heather ash":"#e2e3e5",
    "heather sand":"#9a9887",
    
    /* Blues */
    blau:"#1565c0", blue:"#1565c0", navy:"#1f2a44", "french navy":"#273243", "royal blue":"#2c5fb8", "majorelle blue":"#21428c", "indigo blue":"#2e425a",
    "sky blue":"#8ec5e8", "bright blue":"#00599a", "serene blue":"#8fa8c6", "stone blue":"#597a8b", "blue soul":"#8eb5d9", "kinda blue":"#4f6d81",
    "velocity blue":"#436184", /* Gefixt: Screenshot */
    
    /* Greens */
    grün:"#2e7d32", gruen:"#2e7d32", green:"#2e7d32", "bottle green":"#143d34", "kelly green":"#005c3a",
    "glazed green":"#10473e", "green bay":"#3a5f55", teal:"#25585b", "linden green":"#9eb281",
    sage:"#9caf88", aloe:"#6f8f85", "stem green":"#859b73", mint:"#8ec4a7", "dusty mint":"#a1c0b3",
    "forrest green":"#3c4639", "forest green":"#3c4639", /* Gefixt: Screenshot */
    "teal monstera":"#80a99c", /* Gefixt: Screenshot */
    
    /* Reds, Pinks & Purples */
    rot:"#c62828", red:"#c62828", burgundy:"#5d1f29", "sunset orange":"#df573a", melon:"#f29b7b",
    "cotton pink":"#f4c7c3", pink:"#f2b2c3", "canyon pink":"#d9857d", plum:"#4a2c3a", "day fall":"#bd8a83", "rose clay":"#c48b87",
    "hibiscus rose":"#96626d", /* Gefixt: Screenshot */
    lavender:"#b4a6c5", "lavender dawn":"#b7a8c4", lilac:"#c8a2c8", opal:"#a3c3be", orchid:"#9f7a9d",
    "orchid flower":"#9d3171",
    
    /* Yellows, Earth, Nature & Browns */
    "india ink grey":"#2f353b", stargazer:"#19414b",
    khaki:"#6a6256", beige:"#c8c1ae", sand:"#c8c1ae", latte:"#cc966c", camel:"#ad8451", ochre:"#cc8225", mustard:"#d5a824", "desert dust":"#e3d6c7",
    "natural raw":"#efe8d8", natural:"#efe7da",
    nispero:"#d6a461" /* Gefixt: Screenshot */
  };
  const guessColor = (label)=>{
    const t=(label||"").toString().trim().toLowerCase();
    const hex=t.match(/#([0-9a-f]{3,8})/i); if (hex) return hex[0];
    return COLOR_HEX[t] || "#ddd";
  };

  const GLOBAL_SWATCH_MAP = (() => {
    const base = (window.__RRX_SWATCH_MAP__ && typeof window.__RRX_SWATCH_MAP__ === "object") ? window.__RRX_SWATCH_MAP__ : {};
    return Object.assign(base, { "fraiche-peche": "https://cdn.shopify.com/s/files/1/0762/5343/0089/files/FRAICHE-PECHE.png?v=1715326894" });
  })();

  const BASIC_HEX_SWATCHES = new Set(["black","schwarz","white","weiss","weiß"]);

  function themeSwatchUrlFromCSS(handle){
    const h = handle.toLowerCase();
    const selectorsToLookFor = [ `[data-swatch="${h}"]`, `[data-swatch-handle="${h}"]`, `.color-swatch__item--${h}`, `.color-swatch--${h}`, `.product-form__swatch--${h}`, `.swatch-${h}`, `.is-swatch-${h}` ];
    try{
      for (const ss of Array.from(document.styleSheets)){
        let rules; try{ rules = ss.cssRules || ss.rules; }catch(_){ continue; }
        if (!rules) continue;
        for (const r of Array.from(rules)){
          if (!r || !r.selectorText || !r.style) continue;
          const bg = r.style.backgroundImage || "";
          if (!bg || !bg.includes("url(")) continue;
          if (!selectorsToLookFor.some(sel => r.selectorText.includes(sel))) continue;
          const m = bg.match(/url\((['"]?)(.*?)\1\)/i);
          if (m && m[2]) return m[2];
        }
      }
    }catch(_){}
    return "";
  }

  function probeImage(url, timeoutMs=350){
    return new Promise((res)=>{
      const img = new Image();
      let done=false, t=setTimeout(()=>{ if(!done){done=true;res(false);} }, timeoutMs);
      img.onload = ()=>{ if(!done){ done=true; clearTimeout(t); res(true);} };
      img.onerror= ()=>{ if(!done){ done=true; clearTimeout(t); res(false);} };
      img.src = url;
    });
  }
  async function firstExistingUrl(urls){ for (const u of urls){ if (await probeImage(u)) return u; } return ""; }

 async function resolveSwatchUrl(label){
    const h   = handleize(label);
    const hex = guessColor(label);

    /* 1. Check auf statisch definierte Map (Extrem schnell, kein Netzwerk-Raten) */
    if (GLOBAL_SWATCH_MAP && GLOBAL_SWATCH_MAP[h]){
      const mapped = GLOBAL_SWATCH_MAP[h];
      return mapped.startsWith("http")||mapped.startsWith("/") ? mapped : cdnFile(mapped);
    }

    /* 2. Check auf Basic Colors */
    if (BASIC_HEX_SWATCHES.has(h)) {
      return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(`<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20'><rect width='20' height='20' fill='${hex}'/></svg>`)}`;
    }

    /* 3. Check, ob das Theme die Farbe bereits im CSS hat */
    const cssUrl = themeSwatchUrlFromCSS(h);
    if (cssUrl) return cssUrl;

    /* 4. SPEEDSHOP FIX: Brute-Force Netzwerk-Suche eliminiert. 
       Gibt sofort den errechneten Hex-Code als Inline-SVG zurück, 
       um 404-Spam und LCP-Verzögerungen zu stoppen. */
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(`<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20'><rect width='20' height='20' fill='${hex}'/></svg>`)}`;
  }

  const QV      = byId("rrx-qv");
  const QV_BODY = QV?.querySelector(".rrx-qv-body");
  function closeQuickView(){ if (!QV) return; QV.setAttribute("aria-hidden","true"); if (QV_BODY) QV_BODY.innerHTML = ""; }
  QV?.querySelector(".rrx-qv-close")?.addEventListener("click", closeQuickView);
  QV?.querySelector(".rrx-qv-backdrop")?.addEventListener("click", closeQuickView);

  function openQuickView(p, listName = "Direkt über Produktseite"){
    const QV      = document.getElementById("rrx-qv");
    const QV_BODY = QV?.querySelector(".rrx-qv-body");
    const drawer  = document.getElementById("rrx-cart-drawer");
    if (!drawer || !QV || !QV_BODY) return;
    if ((drawer.dataset.quick||"true")!=="true") return;

    const options  = Array.isArray(p?.options)  ? p.options  : [];
    const variants = Array.isArray(p?.variants) ? p.variants : [];
    const imgUrlW = (src,w)=>{ try{ const u=new URL(src,location.origin); if(w) u.searchParams.set("width",String(w)); return u.toString(); }catch(_){ return src; } };
    const productImg = (pp,w)=>{ const s=(pp?.featured_image&&(pp.featured_image.src||pp.featured_image))||pp?.image||(pp?.images?.[0]||""); return imgUrlW(s,w); };
    const varImg = (v,w)=> imgUrlW((v?.featured_image && (v.featured_image.src||v.featured_image)) || v?.image || (p?.featured_image && (p.featured_image.src||p.featured_image)) || p?.image || (p?.images?.[0]||""), w);

    let active   = variants.find(v=>v.available) || variants[0] || null;
    let selected = (active?.options || []).slice();
// ========================================================
      // ARCHITECT FIX: Quick View "view_item" Trigger
      // ========================================================
      try {
          if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
              window.Shopify.analytics.publish('custom_drawer_view_item', { list_name: listName, product: p, variant: active });
          }
      } catch(e){}

    let SIZE_IDX = -1;
    let sizeBlock = null;

    function markSizeAvailability(){
      if (SIZE_IDX < 0 || !sizeBlock) return;

      const avail = new Set();
      (variants || []).forEach(v => {
        if (!v?.available) return;
        let ok = true;
        (v.options || []).forEach((val, i) => {
          if (i === SIZE_IDX) return;
          if (selected[i] && selected[i] !== val) ok = false;
        });
        if (ok) avail.add(String(v.options[SIZE_IDX]).trim().toLowerCase());
      });

      const btns = sizeBlock.querySelectorAll(".qv-opt-btn");
      let firstAvailBtn = null;

      btns.forEach(btn => {
        const val = (btn.dataset.value || btn.textContent || "").trim().toLowerCase();
        const ok  = avail.has(val);

        btn.classList.toggle("soldout", !ok);
        btn.toggleAttribute("disabled", !ok);            
        btn.setAttribute("aria-disabled", !ok ? "true" : "false");
        if (!ok) btn.classList.remove("is-active");

        if (ok && !firstAvailBtn) firstAvailBtn = btn;
      });

      const cur = (selected[SIZE_IDX] || "").trim().toLowerCase();
      if (!avail.has(cur) && firstAvailBtn){
        selected[SIZE_IDX] = firstAvailBtn.dataset.value || firstAvailBtn.textContent;
        btns.forEach(b => b.classList.remove("is-active"));
        firstAvailBtn.classList.add("is-active");
        updateVariant();
        updateImagePreview();
      }
    }

    QV_BODY.innerHTML = `
      <div class="rrx-qv-head" style="text-align:center">
        <figure class="qv-pic">
          <img class="qv-img" src="${productImg(p,540)}" alt="${(p?.title||'').replace(/"/g,'&quot;')}">
          
          <button class="rrx-qv-size" type="button" aria-label="Größentabelle" title="Größentabelle" data-action="open-size-chart" data-url="${p?.url || `/products/${p.handle}`}" data-title="${(p?.title||'').replace(/"/g,'&quot;')}">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="pointer-events: none;" width="20" height="20">
              <rect x="2" y="8" width="20" height="8" rx="2" ry="2"></rect>
              <line x1="6" y1="8" x2="6" y2="11"></line>
              <line x1="10" y1="8" x2="10" y2="13"></line>
              <line x1="14" y1="8" x2="14" y2="11"></line>
              <line x1="18" y1="8" x2="18" y2="13"></line>
            </svg>
          </button>
          
          <button class="rrx-qv-eye" type="button" aria-label="Bild vergrößern" title="Bild vergrößern"><span aria-hidden="true"></span></button>
        </figure>
        <h3 class="qv-title">${p?.title||""}</h3>
      </div>
      <div class="rrx-qv-options"></div>
      <div class="qv-actions">
        <button class="rrx-btn rrx-btn--xl" data-qv-add disabled><span>In den Warenkorb</span></button>
        <div class="qv-share" data-qv-share></div>
      </div>
    `;

    const imgEl  = QV_BODY.querySelector(".qv-img");
    const eyeBtn = QV_BODY.querySelector(".rrx-qv-eye");
    const addBtn = QV_BODY.querySelector("[data-qv-add]");
    const optWrap= QV_BODY.querySelector(".rrx-qv-options");
    const sizeBtn = QV_BODY.querySelector(".rrx-qv-size");

    if (sizeBtn) {
      // SPEED-FIX: Prefetch startet sofort im Hintergrund, blockiert aber nicht das Rendern!
      const url = sizeBtn.dataset.url;
      const prefetchPromise = fetch(url).then(res => res.text()).catch(() => null);

      sizeBtn.addEventListener("click", async (e) => {
        e.preventDefault(); e.stopPropagation();
        
        sizeBtn.style.opacity = "0.5";
        sizeBtn.style.pointerEvents = "none";
        
        try {
          // Wir warten auf das bereits laufende Prefetch, statt einen neuen Request zu starten
          const text = await prefetchPromise;
          if (!text) throw new Error("Fetch failed");
          
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const tmpl = doc.querySelector('template[id^="tmpl-size-chart-"]');
          
          if (tmpl) {
            const drawerId = tmpl.id.replace('tmpl-', '') + '-qv-isolated';
            
            let drawer = document.getElementById(drawerId);
            if (!drawer) {
              const clone = tmpl.content.cloneNode(true);
              const overlay = clone.querySelector('.custom-sc-overlay');
              if (overlay) {
                overlay.id = drawerId;
                overlay.removeAttribute('onclick');
              }
              document.body.appendChild(clone);
              
              drawer = document.getElementById(drawerId);
              
              const closeHandler = (ev) => {
                if (ev) { ev.preventDefault(); ev.stopPropagation(); try { ev.stopImmediatePropagation(); } catch(_){} }
                drawer.classList.remove('open');
                setTimeout(() => { drawer.style.display = 'none'; }, 300);
              };
              
              drawer.querySelector('.custom-sc-close')?.addEventListener('click', closeHandler);
              drawer.addEventListener('click', (ev) => { if (ev.target === drawer) closeHandler(ev); });
              drawer.querySelector('.custom-sc-content')?.addEventListener('click', (ev) => ev.stopPropagation());
            }
            
            drawer.style.display = 'flex';
            void drawer.offsetWidth;
            drawer.classList.add('open');
          } else {
            window.location.href = url;
          }
        } catch (_) {
          window.location.href = url;
        } finally {
          sizeBtn.style.opacity = "1";
          sizeBtn.style.pointerEvents = "auto";
        }
      });
    }

    function previewCandidate(){
      const cand = variants.filter(v => (v.options||[]).every((o,i)=> !selected[i] || o===selected[i]));
      return cand.find(v=>v.available) || cand[0] || active || variants[0] || null;
    }
    function updateVariant(){
      active = variants.find(v => (v.options||[]).every((o,i)=>o===selected[i])) || null;
      addBtn.disabled = !active || active.available===false;
    }
    function updateImagePreview(){
      const v = previewCandidate();
      const sm = varImg(v,540);
      const xl = varImg(v,1600);
      if (imgEl && imgEl.src !== sm) imgEl.src = sm;
      
      // SPEEDSHOP-FIX: Zoom-Event für die Lupe UND das Bild aktivieren
      if (eyeBtn) eyeBtn.onclick = () => openZoom(xl);
      if (imgEl) {
        imgEl.onclick = () => openZoom(xl);
        imgEl.style.cursor = "zoom-in";
      }
    }
    function updateColorLabelTitles(){
      optWrap.querySelectorAll(".qv-opt").forEach((optEl,optIdx)=>{
        const valSpan = optEl.querySelector(".qv-opt-selected-val");
        if (valSpan) valSpan.textContent = selected[optIdx] || "";
      });
    }

    options.forEach((opt, idx) => {
        const label   = (opt?.name || opt || "").toString();
        const isColor = /(^|[^a-z])(farbe|color)([^a-z]|$)/i.test(label);
        const isSize  = /(größe|groesse|size)/i.test(label);
        const values  = Array.from(new Set(variants.map(v => v.options?.[idx]).filter(Boolean)));

        const block = document.createElement("div");
        block.className   = "qv-opt";
        block.dataset.name= label;
        if (isColor) block.classList.add("qv-opt--color");
        if (isSize)  block.classList.add("qv-opt--size");
        
        block.innerHTML = `
          <div class="qv-opt-label" style="margin-bottom: 12px; font-size: 14px; font-weight: 700; color: #56675D; text-align: center; display: flex; gap: 8px; align-items: baseline; justify-content: center;">
            ${label}: <span class="qv-opt-selected-val" style="font-weight: 700; font-size: 16px; color: #56675D;"></span>
          </div>
          <div class="qv-opt-carousel-wrapper" style="position: relative; width: 100%; display: block; box-sizing: border-box; text-align: center;">
            <button type="button" class="qv-carousel-arrow left" onclick="this.nextElementSibling.scrollBy({left: -150, behavior: 'smooth'})" style="display: none; position: absolute; left: 0px; top: 50%; transform: translateY(-50%); z-index: 5; background: #f5f3ef; border: 1px solid rgba(0,0,0,0.1); border-radius: 4px; width: 34px; height: calc(100% - 4px); box-shadow: 3px 0 8px rgba(0,0,0,0.05); cursor: pointer; align-items: center; justify-content: center; padding: 0;">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
            </button>
            <div class="qv-opt-values" style="display: flex; flex-wrap: nowrap !important; overflow-x: auto; scroll-behavior: smooth; scrollbar-width: none; -ms-overflow-style: none; padding: 4px 12px; gap: 8px; max-width: 100%; width: max-content; margin: 0 auto; justify-content: flex-start; -webkit-overflow-scrolling: touch;" onscroll="
              this.previousElementSibling.style.display = this.scrollLeft > 5 ? 'flex' : 'none';
              this.nextElementSibling.style.display = this.scrollLeft >= (this.scrollWidth - this.clientWidth - 5) ? 'none' : 'flex';
            "></div>
            <button type="button" class="qv-carousel-arrow right" onclick="this.previousElementSibling.scrollBy({left: 150, behavior: 'smooth'})" style="display: none; position: absolute; right: 0px; top: 50%; transform: translateY(-50%); z-index: 5; background: #f5f3ef; border: 1px solid rgba(0,0,0,0.1); border-radius: 4px; width: 34px; height: calc(100% - 4px); box-shadow: -3px 0 8px rgba(0,0,0,0.05); cursor: pointer; align-items: center; justify-content: center; padding: 0;">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
            </button>
          </div>
        `;
        const row = block.querySelector(".qv-opt-values");

        if (isSize) { SIZE_IDX = idx; sizeBlock = block; }

      values.forEach(v => {
        const b = document.createElement("button");
        b.type = "button"; b.className = "qv-opt-btn"; b.textContent = v; b.dataset.value = v; 
        b.style.flexShrink = "0"; /* Verhindert das Quetschen der Buttons im Karussell */

        if (isColor){
          const h = (String(v)||"").trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/[^a-z0-9]+/g,"-").replace(/(^-|-$)/g,"");
          const fallback = guessColor(v);
          b.dataset.swatchH = h;
          b.style.setProperty("--swatch", fallback);
          b.setAttribute("aria-label", v);
          b.textContent = "";
          (async()=>{ try{
            const u = await resolveSwatchUrl(v);
            if (u){ b.style.backgroundImage=`url("${u}")`; b.style.backgroundSize="cover"; b.style.backgroundPosition="center"; b.style.backgroundRepeat="no-repeat"; }
          }catch(_){}})();
        }

        if (isSize && v.trim().length > 3) b.classList.add("is-pill");
        if ((selected[idx]||"") === v) b.classList.add("is-active");

        b.addEventListener("click", () => {
          row.querySelectorAll(".qv-opt-btn").forEach(x => x.classList.remove("is-active"));
          b.classList.add("is-active");
          selected[idx] = v;
          updateVariant(); updateColorLabelTitles(); updateImagePreview(); markSizeAvailability();
        });

        row.appendChild(b);
      });

      optWrap.appendChild(block);

      // Arrow-Check nach dem Rendern
      setTimeout(() => {
        if (row.scrollWidth > row.clientWidth) {
          row.nextElementSibling.style.display = 'flex';
        }
      }, 50);
    });

      updateVariant(); updateColorLabelTitles(); updateImagePreview(); markSizeAvailability();

      // 🚨 SPEEDSHOP FIX: Logik in eine Variable ausgelagert, um Click & Touchend sicher abzufangen
      const handleModalATC = async (ev) => {
        if (ev) {
          ev.preventDefault();
          ev.stopPropagation(); // Verhindert, dass das Modal den Tap verschluckt
        }
        
        // Sicherheitscheck: Wurde eine Variante gewählt?
        if (!active || !active.id) return;

        // Button visuell sperren (verhindert Double-Clicks und ungeduldige Mehrfach-Käufe)
        addBtn.style.opacity = "0.6";
        addBtn.style.pointerEvents = "none";

        // 1. Quelle markieren
        const sourceValue = (listName === "Recently Viewed") ? "cart_recently_viewed" : "cart_recommendation";
        document.cookie = `rrx_atc_source=${sourceValue}; max-age=10; path=/`;

        // ARCHITECT FIX: SANDBOX BRIDGE (ATC Context)
        try {
            if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
                window.Shopify.analytics.publish('rrx_drawer_context', { list_name: listName, variant_id: String(active.id) });
            }
        } catch(e) {}

        // 🚨 SRE FIX: Harte Zuweisung vor dem Fetch!
        window._sre_active_ajax_list = listName;

        // 2. GA4 Tracking (toCents Typsicherheit)
        const price = (typeof toCents === 'function' ? toCents(active.price || 0) : (active.price || 0)) / 100;
        const item = {
          item_id: String(active.id),
          item_name: p?.title || "",
          item_variant: active?.title || "",
          item_brand: p?.vendor || "",
          price,
          quantity: 1,
          item_list_name: listName
        };
        if (typeof dl === 'function') dl("add_to_cart", { currency: CURRENCY, value: price, items: [item] });

        // 3. Bestehendes Tracking & Logik
        try { window.RRXFireATCOnce?.({ id: active.id, quantity: 1 }); } catch (_) {}
        try {
          if (typeof META_PIXEL_BRIDGE_ENABLED !== 'undefined' && META_PIXEL_BRIDGE_ENABLED) { 
            MPX.track("AddToCart", { content_ids: [String(active.id)], content_type: 'product', value: price, currency: CURRENCY }); 
          }
        } catch (_) {}

        // 🚨 SPEEDSHOP FIX: Variable auf active.id korrigiert!
        await fetch(getRoute("cart/add.js"), {
          method: "POST", 
          headers: { "Content-Type": "application/json" }, 
          body: JSON.stringify({ id: active.id, quantity: 1 })
        }).catch(()=>{});

        // Quick-View DOM Elemente neu greifen und schließen
        const currentQV = document.getElementById("rrx-qv");
        if (currentQV) currentQV.setAttribute("aria-hidden", "true");
        
        // Cart-Drawer aktualisieren und öffnen
        if (typeof window.RRXCartDrawer !== "undefined") {
            window.RRXCartDrawer.refresh(false);
            window.RRXCartDrawer.open();
        }

        // Erfolgs-Banner triggern
        if (typeof window.RRXShowSuccessBanner === "function") {
            window.RRXShowSuccessBanner();
        }

        // 🚨 SPEEDSHOP UX FIX: Automatischer Wechsel zum Warenkorb-Tab nach Quick-View ATC
        if (typeof showView === "function") {
            showView("cart");
        } else {
            // Fallback: Simulierter Klick auf den Tab
            const cartTab = document.querySelector('#rrx-cart-drawer [data-tab="cart"], #rrx-cart-drawer [data-tab="overview"]');
            if (cartTab) cartTab.click();
        }
        
        // Fallback: Button nach 1 Sekunde wieder freigeben (falls der Kunde das Modal später erneut öffnet)
        setTimeout(() => {
            if (addBtn) {
                addBtn.style.opacity = "1";
                addBtn.style.pointerEvents = "auto";
            }
        }, 1000);
      };

      // 🚨 SPEEDSHOP FIX: Doppeltes Binding für maximales Ansprechverhalten auf Mobile (iOS Safari)
      addBtn.addEventListener("click", handleModalATC);
      addBtn.addEventListener("touchend", handleModalATC, { passive: false });

    (function renderShare(){
      const wrap = QV_BODY.querySelector("[data-qv-share]");
      if (!wrap) return;
      const url = location.origin + (p?.url || (p?.handle ? `/products/${p.handle}` : "#"));
      const txt = encodeURIComponent(p?.title || document.title);
      const img = encodeURIComponent(productImg(p,540));
      const add = (cls,title,href,txtc)=>{ const a=document.createElement("a"); a.className=`qv-share-btn ${cls}`; a.href=href; a.target="_blank"; a.rel="noopener"; a.title=title; a.textContent=txtc; wrap.appendChild(a); };
      if ((drawer.dataset.shareFb||"true")==="true") add("fb","Facebook",`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,"f");
      if ((drawer.dataset.sharePinterest||drawer.dataset.sharePin||"true")==="true") add("pin","Pinterest",`https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&media=${img}&description=${txt}`,"P");
      if ((drawer.dataset.shareWhatsapp||drawer.dataset.shareWa||"true")==="true") add("wa","WhatsApp",`https://wa.me/?text=${txt}%20-%20${encodeURIComponent(url)}`,"WA");
      if ((drawer.dataset.shareEmail||drawer.dataset.shareMail||"true")==="true") add("mail","E-Mail",`mailto:?subject=${txt}&body=${txt}%0A%0A${encodeURIComponent(url)}`,"@");
    })();

    ensureZoomOverlay();
    QV.setAttribute("aria-hidden","false");
    QV.querySelector(".rrx-qv-close")?.addEventListener("click", ()=> QV.setAttribute("aria-hidden","true"), {once:true});
    QV.querySelector(".rrx-qv-backdrop")?.addEventListener("click", ()=> QV.setAttribute("aria-hidden","true"), {once:true});
  }


  /* 🚨 SPEEDSHOP FIX: DOMParser CPU-Fresser eliminiert & durch Caching + Regex ersetzt */
  async function loadLiveStars(handle, container) {
  try {
    if (!handle) return;
    let html = "";
    if (LOOX_CACHE.has(handle)) {
      html = LOOX_CACHE.get(handle);
    } else {
      const res = await fetch(getRoute(`products/${handle}`));
      html = await res.text();
      LOOX_CACHE.set(handle, html);
    }
    
    let rating = 0;
    let raters = 0;
    
    // High-Performance Regex statt Parser: Sucht nach loox-rating MIT data-id (ignoriert Globale Badges)
    const looxTagMatch = html.match(/<[^>]+loox-rating[^>]+data-id=[^>]+>|<[^>]+data-id=[^>]+loox-rating[^>]+>/i);
    
    if (looxTagMatch) {
      const ratingMatch = looxTagMatch[0].match(/data-rating="([\d.]+)"/i);
      const ratersMatch = looxTagMatch[0].match(/data-raters="(\d+)"/i);
      if (ratingMatch && ratersMatch) {
         rating = parseFloat(ratingMatch[1]);
         raters = parseInt(ratersMatch[1], 10);
      }
    }
    
    if (raters > 0) {
      
      if (raters > 0) {
        const floor = Math.floor(rating);
        const decimal = rating - floor;
        let starsHtml = '';
        
        for (let i = 1; i <= 5; i++) {
          if (rating >= i) {
            starsHtml += '<div style="line-height: 0; display: flex; justify-content: center;"><div class="rrx-star-wrapper"><svg class="rrx-custom-star-icon rrx-custom-star-filled" viewBox="0 0 24 24"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg></div></div>';
          } else if (decimal >= 0.3 && i === floor + 1) {
            starsHtml += '<div style="line-height: 0; display: flex; justify-content: center;"><div class="rrx-star-wrapper"><div style="position: absolute; top:0; left:0; z-index: 1;"><svg class="rrx-custom-star-icon" style="color: #d1d5db; fill: #d1d5db;" viewBox="0 0 24 24"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg></div><div style="position: absolute; top:0; left:0; z-index: 2; width: 50%; overflow: hidden;"><svg class="rrx-custom-star-icon rrx-custom-star-filled" style="min-width: 100%;" viewBox="0 0 24 24"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg></div></div></div>';
          } else {
            starsHtml += '<div style="line-height: 0; display: flex; justify-content: center;"><div class="rrx-star-wrapper"><svg class="rrx-custom-star-icon" style="color: #d1d5db; fill: #d1d5db;" viewBox="0 0 24 24"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg></div></div>';
          }
        }
        
        container.innerHTML = `
          <div class="rrx-rating-wrapper" role="button" aria-label="${rating} von 5 Sternen - Bewertungen ansehen" tabindex="0">
            <div class="rrx-rating-bubble rrx-bubble-stars">
              ${starsHtml}
            </div>
            <div class="rrx-rating-bubble rrx-bubble-count">
              <span class="rrx-review-count-text">${raters}</span>
            </div>
          </div>
        `;
        
        const wrapper = container.querySelector('.rrx-rating-wrapper');
        if (wrapper) {
          wrapper.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            // 1. Overlay (Modal) CSS und Grundgerüst erstellen
            let modal = document.getElementById('rrx-loox-modal');
            if (!modal) {
              const mCss = document.createElement("style");
              mCss.textContent = `
                #rrx-loox-modal { position: fixed; inset: 0; z-index: 1000005; display: none; align-items: center; justify-content: center; background: rgba(0,0,0,0.5); backdrop-filter: blur(4px); opacity: 0; transition: opacity 0.2s ease; }
                #rrx-loox-modal.is-open { display: flex; opacity: 1; }
                .rrx-loox-modal-content { background: #fff; width: 92%; max-width: 400px; border-radius: 12px; display: flex; flex-direction: column; box-shadow: 0 10px 40px rgba(0,0,0,0.15); transform: translateY(20px); transition: transform 0.2s ease; overflow: hidden; }
                #rrx-loox-modal.is-open .rrx-loox-modal-content { transform: translateY(0); }
                .rrx-loox-modal-header { padding: 16px 20px; border-bottom: 1px solid #dbece5; display: flex; justify-content: space-between; align-items: center; background: #f4f8f6; }
                .rrx-loox-modal-header h3 { margin: 0; font-size: 1.1rem; color: #596A60; font-weight: 700; letter-spacing: 0.5px; }
                .rrx-loox-modal-close { background: none; border: none; font-size: 28px; cursor: pointer; color: #596A60; padding: 0; line-height: 1; display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; transition: transform 0.2s; }
                .rrx-loox-modal-close:hover { transform: scale(1.1); }
                .rrx-loox-modal-body { padding: 30px 20px; text-align: center; background: #ffffff; display: flex; flex-direction: column; align-items: center; }
                .rrx-modal-stars { display: flex; justify-content: center; gap: 6px; margin-bottom: 16px; flex-direction: row; }
                .rrx-modal-stars .rrx-star-wrapper { width: 32px !important; height: 32px !important; }
                .rrx-modal-stars svg { width: 32px !important; height: 32px !important; }
                .rrx-modal-rating-text { font-size: 1.3rem; font-weight: 700; color: #1a1a1a; margin-bottom: 6px; }
                .rrx-modal-raters-text { font-size: 0.95rem; color: #666; margin-bottom: 24px; }
                .rrx-loox-redirect-btn { display: inline-flex; align-items: center; justify-content: center; width: 100%; padding: 14px 24px; background: #596A60; color: #fff !important; text-decoration: none; border-radius: 6px; font-weight: 700; font-size: 1rem; transition: filter 0.2s; cursor: pointer; border: none; }
                .rrx-loox-redirect-btn:hover { filter: brightness(1.1); }
              `;
              document.head.appendChild(mCss);

              modal = document.createElement("div");
              modal.id = "rrx-loox-modal";
              document.body.appendChild(modal);
            }

            // 2. Inhalt dynamisch für das geklickte Produkt einfügen
            modal.innerHTML = `
              <div class="rrx-loox-modal-content" onclick="event.stopPropagation()">
                  <div class="rrx-loox-modal-header">
                      <h3>Kundenbewertungen</h3>
                      <button class="rrx-loox-modal-close" aria-label="Schließen">&times;</button>
                  </div>
                  <div class="rrx-loox-modal-body">
                      <div class="rrx-modal-stars">
                          ${starsHtml}
                      </div>
                      <div class="rrx-modal-rating-text">${rating.toFixed(1).replace('.', ',')} von 5 Sternen</div>
                      <div class="rrx-modal-raters-text">Basierend auf ${raters} Bewertungen</div>
                      
                      <button class="rrx-loox-redirect-btn" id="rrx-go-to-reviews">
                        Alle Bewertungen lesen
                      </button>
                  </div>
              </div>
            `;

            // 3. Modal Schließen-Logik
            const closeModal = () => {
              modal.classList.remove('is-open');
              setTimeout(() => { modal.style.display = 'none'; }, 200);
            };
            modal.addEventListener('click', closeModal);
            modal.querySelector('.rrx-loox-modal-close').addEventListener('click', closeModal);

            // 4. Echte, erzwungene Weiterleitung
            modal.querySelector('#rrx-go-to-reviews').addEventListener('click', () => {
               window.location.href = `/products/${handle}#looxReviews`;
               setTimeout(() => { window.location.reload(); }, 50);
            });

            // 5. Modal anzeigen
            modal.style.display = 'flex';
            void modal.offsetWidth; 
            modal.classList.add('is-open');
          });
        }
      } else {
        // Falls 0 Bewertungen gefunden werden, wird nichts gerendert (Container bleibt leer)
        container.innerHTML = "";
      }
    }
  } catch(e) {
    console.warn("Loox Stars Error:", e);
  }
}

  /* Angesehen */
  function dedupeLatestFirst(list){
    const seen=new Set(), out=[];
    for (let i=list.length-1; i>=0; i--){
      const h=list[i];
      if (h && !seen.has(h)){ seen.add(h); out.push(h); }
    }
    return out.reverse();
  }

/* Angesehen */
 /* Angesehen */
  async function renderRecent(){
    const box = drawer.querySelector("[data-rrx-recent]");
    if (!box) return;

    if (!document.getElementById("rrx-recent-enhancements-v5")) {
      const style = document.createElement("style");
      style.id = "rrx-recent-enhancements-v5";
      style.textContent = `
        /* AGGRESSIVES AUSBLENDEN ALLER THEME-ÜBERSCHRIFTEN (ANGESEHEN) */
        #rrx-cart-drawer .rrx-view[data-view="recent"] > h2,
        #rrx-cart-drawer .rrx-view[data-view="recent"] > h3,
        #rrx-cart-drawer .rrx-view[data-view="recent"] > h4,
        #rrx-cart-drawer .rrx-view[data-view="recent"] > .rrx-title,
        #rrx-cart-drawer [data-rrx-recent] > h3,
        #rrx-cart-drawer .rrx-recent-wrap h3,
        #rrx-cart-drawer .rrx-recent-wrap .rrx-title {
          display: none !important;
          opacity: 0 !important;
          visibility: hidden !important;
          height: 0 !important;
          margin: 0 !important;
          padding: 0 !important;
        }

        #rrx-cart-drawer [data-rrx-recent] a {
          display: block !important;
          position: relative !important; /* WICHTIG FÜR DEN BUTTON */
          background: #ffffff !important;
          border-radius: 12px !important; 
          padding: 12px !important; 
          box-shadow: 0 4px 12px rgba(0,0,0,0.08), 0 1px 3px rgba(0,0,0,0.05) !important;
          transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important; 
          text-decoration: none !important;
          height: 100% !important; 
          box-sizing: border-box !important;
          border: 1px solid rgba(0,0,0,0.03) !important; 
        }

        #rrx-cart-drawer [data-rrx-recent] a:hover {
          transform: translateY(-6px) !important; 
          box-shadow: 0 15px 35px rgba(0,0,0,0.12), 0 5px 15px rgba(0,0,0,0.07) !important;
        }

        #rrx-cart-drawer [data-rrx-recent] a img.rrx-recent-img {
          width: 100% !important;
          height: auto !important;
          object-fit: contain !important;
          border-radius: 8px !important; 
          margin-bottom: 10px !important;
          transform: scale(1.05) !important; 
          mix-blend-mode: darken !important;
        }
        
        #rrx-cart-drawer [data-rrx-recent] a .ttl {
          font-size: 0.95rem !important;
          margin-bottom: 6px !important;
          text-align: center !important;
          color: var(--hdc, #2f2f2f) !important;
        }
        #rrx-cart-drawer [data-rrx-recent] a .prc {
          font-size: 0.95rem !important;
          font-weight: 700 !important;
          text-align: center !important;
          color: var(--hdc, #2f2f2f) !important;
        }

        /* NEU: Positionierung des Buttons in den Angesehen-Kacheln */
        @keyframes rrxBtnWaves {
          0% { box-shadow: 0 0 0 0 rgba(46, 125, 50, 0.8), 0 0 0 0 rgba(46, 125, 50, 0.6), 0 0 0 0 rgba(46, 125, 50, 0.4); }
          100% { box-shadow: 0 0 0 4px rgba(46, 125, 50, 0), 0 0 0 8px rgba(46, 125, 50, 0), 0 0 0 12px rgba(46, 125, 50, 0); }
        }
        #rrx-cart-drawer [data-rrx-recent] .rrx-recent-add-btn {
          position: absolute !important;
          bottom: 12px !important;
          right: 12px !important;
          width: 34px !important;
          height: 34px !important;
          border-radius: 50% !important;
          background: var(--ac, #2E7D32) !important;
          color: #fff !important;
          border: none !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          cursor: pointer !important;
          z-index: 10 !important;
          transition: background 0.2s ease, transform 0.2s ease !important;
          padding: 0 !important;
        }
        #rrx-cart-drawer [data-rrx-recent] .rrx-recent-add-btn::before {
          content: "" !important; position: absolute !important; inset: 0 !important; border-radius: inherit !important; pointer-events: none !important;
          animation: rrxBtnWaves 2s cubic-bezier(0.16, 1, 0.3, 1) infinite !important; z-index: -1 !important;
        }
        #rrx-cart-drawer [data-rrx-recent] .rrx-recent-add-btn:hover {
          background: #1A5E20 !important;
          transform: scale(1.1) !important;
        }
        #rrx-cart-drawer [data-rrx-recent] .rrx-recent-add-btn:hover::before { animation: none !important; }
        #rrx-cart-drawer [data-rrx-recent] .rrx-recent-add-btn svg {
          width: 16px !important;
          height: 16px !important;
          fill: #ffffff !important;
          stroke: none !important;
        }
        @media (max-width: 760px) {
          #rrx-cart-drawer [data-rrx-recent] .rrx-recent-add-btn {
            bottom: 8px !important;
            right: 8px !important;
            width: 30px !important;
            height: 30px !important;
          }
          #rrx-cart-drawer [data-rrx-recent] .rrx-recent-add-btn svg { width: 14px !important; height: 14px !important; }
        }
      `;
      document.head.appendChild(style);
    }

    const raw = localStorage.getItem("rrx_recent_handles") || "";
    const handles = dedupeLatestFirst(raw.split(",").filter(Boolean)).slice(0, 8);

    if (!handles.length) {
       box.innerHTML = "<p style='grid-column:1/-1;text-align:center;padding:20px;color:#666'>Noch nichts angesehen.</p>";
       return;
    }
    
    box.innerHTML = "";

    const promises = handles.map(h => fetch(getRoute(`products/${encodeURIComponent(h)}.js`)).then(r => r.ok ? r.json() : null).catch(() => null));
    const products = await Promise.all(promises);

    for (const p of products){
      if (!p) continue; 
      
      const img = (p.featured_image && (p.featured_image.src || p.featured_image)) || p.image || p.images?.[0] || "";
      const price = p.price_min || p.price || (p.variants && p.variants[0] ? p.variants[0].price : 0);

      // Erste verfügbare Variante für den ATC-Button ermitteln
      const firstAvailVariant = p.variants && p.variants.find(v => v.available);
      const variantId = firstAvailVariant ? firstAvailVariant.id : "";

      const a = document.createElement("a");
      a.href = p.url || `/products/${p.handle}`;
      a.innerHTML = `
        <div style="position: relative; width: 100%; border-radius: 8px; overflow: hidden; margin-bottom: 10px; background: #fff;">
          <img class="rrx-recent-img" src="${imgUrl(img, 420)}" alt="${p.title}" loading="lazy" decoding="async" style="display: block; margin: 0; width: 100%; height: auto; object-fit: contain;"><div class="rrx-live-stars" data-handle="${p.handle}"></div>
        </div>
        <div class="ttl" style="font-weight:600;line-height:1.2;color:var(--hdc);text-align:center;">${p.title}</div>
        <div class="prc" style="font-weight:700;text-align:center;color:var(--hdc);">${moneyFmt(toCents(price))}</div>
        ${variantId ? `<button class="rrx-quick-add-btn rrx-recent-add-btn" type="button" data-variant-id="${variantId}" aria-label="Direkt in den Warenkorb">
          <svg viewBox="0 0 24 24"><path d="M9 20a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-7.5-2h8.6a2 2 0 0 0 1.95-1.57l1.7-7.64a1 1 0 0 0-.96-1.21H5.78L5.35 4H2v2h2l3.6 13.59a2 2 0 0 0 1.9 1.41z"/></svg>
        </button>` : ""}
      `;
      
// 🚨 SPEEDSHOP FIX: Automatischer View-Switch & iOS Safari Click-Sicherung für "Angesehen"
      const quickAddBtn = a.querySelector(".rrx-recent-add-btn");
      if (quickAddBtn) {
        const handleRecentATC = async (ev) => {
          if (ev) {
            ev.preventDefault();
            ev.stopPropagation(); 
          }
          
          const vId = quickAddBtn.dataset.variantId;
          if (!vId) return;

          // === KONTEXT-BRÜCKE ZUM PIXEL SENDEN ===
          try {
             if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
                 window.Shopify.analytics.publish('rrx_drawer_context', { list_name: 'Zuletzt angesehen', variant_id: String(vId) });
             }
          } catch(e) {}

          quickAddBtn.style.opacity = "0.6";
          quickAddBtn.style.pointerEvents = "none";
          
          // 🚨 SRE FIX: Harte Zuweisung vor dem Fetch!
          window._sre_active_ajax_list = "Zuletzt angesehen";

          // SpeedShop Fix: Lokalisierte Route für den Fetch
          await fetch(getRoute("cart/add.js"), {
            method: "POST", 
            headers: { "Content-Type": "application/json" }, 
            body: JSON.stringify({ id: vId, quantity: 1 })
          }).catch(()=>{});

          // Drawer Logik aktualisieren
          if (typeof window.RRXCartDrawer !== "undefined") {
            window.RRXCartDrawer.refresh(false);
          }
          if (typeof window.RRXShowSuccessBanner === "function") {
            window.RRXShowSuccessBanner();
          }

          // 🚨 SPEEDSHOP UX FIX: Sofortiger Wechsel in die Hauptansicht (Warenkorb)
          if (typeof showView === "function") {
            showView("cart");
          } else {
            // Fallback, falls showView außerhalb des Scopes liegt
            const cartTab = document.querySelector('#rrx-cart-drawer [data-tab="cart"], #rrx-cart-drawer [data-tab="overview"]');
            if (cartTab) cartTab.click();
          }
        };

        // Doppeltes Binding für maximale Responsiveness
        quickAddBtn.addEventListener("click", handleRecentATC);
        quickAddBtn.addEventListener("touchend", handleRecentATC, { passive: false });
      }
      
      a.addEventListener("click", (ev) => {
        if (typeof QV_ENABLE !== "undefined" && QV_ENABLE) {
          ev.preventDefault(); 
          ev.stopPropagation();
          
          if (typeof QV_CACHE !== "undefined" && typeof openQuickView === "function") {
            if (!QV_CACHE.has(p.handle) && typeof preloadQV === "function") preloadQV(p.handle);
            
            QV_CACHE.get(p.handle).then(prod => {
  openQuickView(prod, "Recently Viewed");
              
              setTimeout(() => {
                const qv = document.getElementById("rrx-qv");
                if (!qv) return;
                const addBtn = qv.querySelector("[data-qv-add]");
                
                if (addBtn && !qv.querySelector('.qv-to-product-link')) {
                  const linkBtn = document.createElement("a");
                  linkBtn.className = "qv-to-product-link";
                  linkBtn.href = `/products/${p.handle}`;
                  linkBtn.innerText = "Zur Produktseite";
                  linkBtn.style.display = "block";
                  linkBtn.style.marginTop = "12px";
                  linkBtn.style.fontSize = "14px";
                  linkBtn.style.fontWeight = "600";
                  linkBtn.style.textDecoration = "underline";
                  linkBtn.style.color = "var(--text-color, #4A5D53)";
                  linkBtn.style.cursor = "pointer";
                  
                  addBtn.parentNode.insertBefore(linkBtn, addBtn.nextSibling);
                }
              }, 10);
            }).catch(() => {
              window.location.href = `/products/${p.handle}`;
            });
          } else {
             window.location.href = `/products/${p.handle}`;
          }
        }
      });
      
      box.appendChild(a);
    }
    
    // Live-Sterne triggern
    box.querySelectorAll('.rrx-live-stars').forEach(container => {
      if(typeof loadLiveStars === 'function') loadLiveStars(container.dataset.handle, container);
    });
  }

  /* --- NEU: MOBILES KARUSSELL UND POSITIONIERUNG --- */
  /* --- NEU: MOBILES KARUSSELL, POSITIONIERUNG UND TAB-NAVIGATION --- */
const MOBILE_MQ = window.matchMedia("(max-width: 760px)");
let __rrxCarouselNav = null;
let __rrxRecoPlaceholder = null; 

function ensureRecoWrap(){
  const reco = drawer.querySelector("[data-rrx-reco]");
  if (!reco) return null;
  if (reco.parentElement?.classList.contains("rrx-reco-wrap")) return reco.parentElement;

  const wrap = document.createElement("div");
  wrap.className = "rrx-reco-wrap";
  reco.parentNode.insertBefore(wrap, reco);

  const title = drawer.querySelector('.rrx-right-h3');
  if (title) wrap.appendChild(title);

  const tabs = document.createElement("div");
  tabs.className = "rrx-reco-tabs";
  tabs.innerHTML = `
    <button type="button" class="rrx-reco-tab-btn is-active" data-tab="socken" aria-label="Socken">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12.5 4v9.5c0 2.5-1.5 4.5-4 5.5-1.5.5-3.5 0-3.5-2s1.5-3 2.5-3.5V4h5z"/></svg>
    </button>
    <button type="button" class="rrx-reco-tab-btn" data-tab="shirts" aria-label="T-Shirts">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.5 5.5l-4.5-2-4 2-4-2-4.5 2v5l2.5-1v10h12v-10l2.5 1v-5z"/></svg>
    </button>
    <button type="button" class="rrx-reco-tab-btn" data-tab="armbaender" aria-label="Armbänder">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="13" r="7"/><rect x="9.5" y="3.5" width="5" height="5" fill="currentColor" stroke="none"/></svg>
    </button>
    <button type="button" class="rrx-reco-tab-btn" data-tab="tassen" aria-label="Tassen">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 8h10v8a4 4 0 01-4 4H9a4 4 0 01-4-4V8z"/><path d="M15 10h2a3 3 0 013 3v0a3 3 0 01-3 3h-2"/></svg>
    </button>
    <button type="button" class="rrx-reco-tab-btn" data-tab="geschenke" aria-label="Geschenke">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path></svg>
    </button>
  `;
  wrap.appendChild(tabs);
      wrap.appendChild(reco);

      // --- NEU: Scroll-Indikator (Pfeil) - NUR DESKTOP ---
      const scrollIndicator = document.createElement("div");
      scrollIndicator.className = "rrx-reco-scroll-arrow";
      scrollIndicator.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
      wrap.appendChild(scrollIndicator);

      // Scroll-Event zum sanften Ausblenden am Ende
      reco.addEventListener('scroll', () => {
        const isBottom = Math.ceil(reco.scrollHeight - reco.scrollTop) <= reco.clientHeight + 15;
        scrollIndicator.style.opacity = isBottom ? "0" : "1";
        scrollIndicator.style.pointerEvents = isBottom ? "none" : "auto";
      }, { passive: true });

      // Klick-Event zum automatischen Scrollen
      scrollIndicator.addEventListener('click', () => {
        reco.scrollBy({ top: 142, behavior: 'smooth' }); // Scrollt exakt 1 Kachel + Gap
      });
      // -------------------------------------

      tabs.querySelectorAll('.rrx-reco-tab-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const targetTab = e.currentTarget.dataset.tab;
          tabs.querySelectorAll('.rrx-reco-tab-btn').forEach(b => b.classList.remove('is-active'));
          e.currentTarget.classList.add('is-active');
          reco.scrollTop = 0; // Reset Scroll-Position beim Tab-Wechsel
          if(window.__rrxRecoCandidates) renderRecoItemsUI(window.__rrxRecoCandidates, targetTab);
        });
      });

      return wrap;
    }

function moveRecoToMobilePosition() {
    const recoWrap = ensureRecoWrap();
    const itemsWrap = drawer.querySelector('[data-rrx-items]') || drawer.querySelector('.Drawer__CartItems, .cart-drawer__items') || drawer.querySelector('.rrx-item')?.parentNode;
    
    if (!recoWrap || !itemsWrap) return;

    if (!__rrxRecoPlaceholder) {
        __rrxRecoPlaceholder = document.createElement('div');
        __rrxRecoPlaceholder.id = 'rrx-reco-placeholder';
        __rrxRecoPlaceholder.style.display = 'none';
        recoWrap.parentNode.insertBefore(__rrxRecoPlaceholder, recoWrap);
    }
    itemsWrap.parentNode.insertBefore(recoWrap, itemsWrap.nextSibling);
}

function restoreRecoPosition() {
    const recoWrap = ensureRecoWrap();
    if (!recoWrap || !__rrxRecoPlaceholder) return;
    __rrxRecoPlaceholder.parentNode.insertBefore(recoWrap, __rrxRecoPlaceholder.nextSibling);
}

function makeRecoCarousel(){
  const reco = drawer.querySelector("[data-rrx-reco]");
  if (!reco) return;
  ensureRecoWrap();
  reco.setAttribute("data-carousel","1");
  if (__rrxCarouselNav) __rrxCarouselNav.style.display = 'none';
}

function teardownRecoCarousel(){
  const reco = drawer.querySelector("[data-rrx-reco]");
  if (!reco) return;
  reco.removeAttribute("data-carousel");
  if (__rrxCarouselNav) __rrxCarouselNav.style.display = '';
}

function syncRecoCarousel(){ 
    if (MOBILE_MQ.matches) {
        makeRecoCarousel();
        moveRecoToMobilePosition();
    } else {
        teardownRecoCarousel();
        restoreRecoPosition();
    }
}

if (MOBILE_MQ.addEventListener) MOBILE_MQ.addEventListener("change", syncRecoCarousel);
else MOBILE_MQ.addListener(syncRecoCarousel);

function renderRecoItemsUI(candidatesArray, activeTab) {
  const box = drawer.querySelector("[data-rrx-reco]");
  if (!box) return;

 let filtered = candidatesArray.filter(p => {
    const titleType = `${p.type || p.product_type || ""} ${p.title || ""}`.toLowerCase();
    const pTags = Array.isArray(p.tags) ? p.tags.map(t => String(t).toLowerCase()) : [];

    if (activeTab === 'socken') return titleType.includes('socken') || pTags.some(t=>t.includes('socken'));
    if (activeTab === 'shirts') {
      const isSweater = titleType.includes('sweat') || titleType.includes('pullover') || titleType.includes('hoodie');
      const isPolo = titleType.includes('polo');
      return (titleType.includes('shirt') || titleType.includes('t-shirt')) && !isSweater && !isPolo;
    }
    if (activeTab === 'armbaender') return titleType.includes('armband') || titleType.includes('schlüssel') || pTags.some(t=>t.includes('armband') || t.includes('schlüssel'));
    if (activeTab === 'tassen') return titleType.includes('tasse') || titleType.includes('mug');
    if (activeTab === 'geschenke') return pTags.some(t => t === 'tipp');
    return false;
  });

  // --- NEU: DYNAMISCHE ÜBERSCHRIFT (Inkl. Socken-Logik) ---
  const cartNodesH3 = document.querySelectorAll('#rrx-cart-drawer .rrx-item-title, #rrx-cart-drawer .rrx-item-meta');
  const isCartEmpty = document.querySelectorAll('#rrx-cart-drawer .rrx-item').length === 0;
  const hasSocksInCart = Array.from(cartNodesH3).some(el => el.textContent.toLowerCase().includes('socken'));
  const h3Title = document.querySelector('#rrx-cart-drawer .rrx-right-h3');
  
  if (h3Title) {
    if (isCartEmpty) {
      h3Title.textContent = "Unsere Empfehlungen für dich";
    } else if (activeTab === 'socken') {
      h3Title.textContent = hasSocksInCart ? "Perfekt dazu kombinierbar:" : "Wird häufig zusammen gekauft:";
    } else if (activeTab === 'geschenke') {
      h3Title.textContent = "Wird häufig verschenkt:";
    } else {
      h3Title.textContent = "Das passt zusammen:";
    }
  }

  const finalPicks = [];
  const seenHandles = new Set();
  
  // NEU: Max-Limit dynamisch auf 5 drosseln, wenn Socken aktiv sind
  const maxItems = (activeTab === 'socken') ? 5 : 10;

  if (activeTab === 'shirts') {
    // --- SPEZIAL-LOGIK: SHIRTS (6 Damen, 4 Herren, Fitted-Match) ---
    // Prüfen, ob der Kunde "Fitted" im Cart hat
    const cartNodes = document.querySelectorAll('#rrx-cart-drawer .rrx-item-title, #rrx-cart-drawer .rrx-item-meta');
    const hasFitted = Array.from(cartNodes).some(el => el.textContent.toLowerCase().includes('fitted'));
    
    let damenShirts = [];
    let herrenShirts = [];
    
    filtered.forEach(p => {
      const titleType = `${p.type || p.product_type || ""} ${p.title || ""}`.toLowerCase();
      const pTags = Array.isArray(p.tags) ? p.tags.map(t => String(t).toLowerCase()) : [];
      
      const isHerren = pTags.some(t => t === 'herren' || t === 'männer' || t === 'papa') || titleType.includes('herren') || titleType.includes('männer');
      const isDamen = pTags.some(t => t === 'damen' || t === 'frauen' || t === 'mama') || titleType.includes('damen') || titleType.includes('frauen');
      const isVNeck = titleType.includes('v-neck') || titleType.includes('v-ausschnitt');
      const isFitted = titleType.includes('fitted');
      
      // Fitted-Matching Bonus (50 Extra-Punkte, wenn die Vorliebe mit dem Cart übereinstimmt)
      let shirtScore = p._score || 0;
      if (hasFitted && isFitted) shirtScore += 50;
      if (!hasFitted && !isFitted) shirtScore += 50;
      p._shirtScore = shirtScore;

      if (isDamen) {
        damenShirts.push(p);
      } else if (isHerren && !isVNeck) { // V-Neck bei Herren hart ausschließen
        herrenShirts.push(p);
      } else if (!isDamen && !isHerren) { // Unisex als Backup in beide Arrays schieben
        if (!isVNeck) herrenShirts.push(p);
        damenShirts.push(p);
      }
    });

    // Nach dem kombinierten _shirtScore sortieren (Cart-Motiv + Fitted Bonus)
    damenShirts.sort((a, b) => b._shirtScore - a._shirtScore);
    herrenShirts.sort((a, b) => b._shirtScore - a._shirtScore);

    // --- Dynamischer 6/4 Split basierend auf Cart-Gender ---
    const targetGender = window.__rrxCartGender || "damen"; // Default ist Damen
    let primaryShirts = targetGender === "herren" ? herrenShirts : damenShirts;
    let secondaryShirts = targetGender === "herren" ? damenShirts : herrenShirts;

    // Max 6 Primary Shirts (Damen ODER Herren, passend zum Cart)
    let primaryCount = 0;
    for (const p of primaryShirts) {
      if (primaryCount >= 6) break;
      if (!seenHandles.has(p.handle)) { finalPicks.push(p); seenHandles.add(p.handle); primaryCount++; }
    }
    
    // Max 4 Secondary Shirts (Das jeweils andere Geschlecht)
    let secondaryCount = 0;
    for (const p of secondaryShirts) {
      if (secondaryCount >= 4 || finalPicks.length >= maxItems) break;
      if (!seenHandles.has(p.handle)) { finalPicks.push(p); seenHandles.add(p.handle); secondaryCount++; }
    }

    // Fallback: Falls der Shop nicht genug passende Shirts hat, mit dem Rest auffüllen
    filtered.sort((a, b) => (b._shirtScore || 0) - (a._shirtScore || 0));
    for (const p of filtered) {
      if (finalPicks.length >= maxItems) break;
      if (!seenHandles.has(p.handle)) { finalPicks.push(p); seenHandles.add(p.handle); }
    }

  } else {
    // --- STANDARD-LOGIK FÜR ALLE ANDEREN TABS (STRIKTE GENDER-TRENNUNG & SPLIT) ---
    filtered.sort((a, b) => (b._score || 0) - (a._score || 0));
    
    let damenItems = [];
    let herrenItems = [];
    let unisexItems = [];

    filtered.forEach(p => {
      const titleType = `${p.type || p.product_type || ""} ${p.title || ""}`.toLowerCase();
      const pTags = Array.isArray(p.tags) ? p.tags.map(t => String(t).toLowerCase()) : [];
      const isHerren = pTags.some(t => t === 'herren' || t === 'männer' || t === 'papa') || titleType.includes('herren') || titleType.includes('männer');
      const isDamen = pTags.some(t => t === 'damen' || t === 'frauen' || t === 'mama') || titleType.includes('damen') || titleType.includes('frauen');

      if (isDamen && !isHerren) damenItems.push(p);
      else if (isHerren && !isDamen) herrenItems.push(p);
      else unisexItems.push(p);
    });

    const isMixed = window.__rrxIsCartHerren && window.__rrxIsCartDamen;
    const onlyHerren = window.__rrxIsCartHerren && !window.__rrxIsCartDamen;
    const onlyDamen = window.__rrxIsCartDamen && !window.__rrxIsCartHerren;

    const applyDiversity = (pool) => {
      if (activeTab !== 'geschenke' && window.__rrxActiveMotifs && window.__rrxActiveMotifs.length > 1) {
        for (const motif of window.__rrxActiveMotifs) {
          const match = pool.find(p => !seenHandles.has(p.handle) && p._matchedMotifs && p._matchedMotifs.includes(motif));
          if (match) { finalPicks.push(match); seenHandles.add(match.handle); }
        }
      }
    };

    if (onlyHerren) {
      // Strikt Herren + Unisex (Damen komplett blockiert)
      let pool = [...herrenItems, ...unisexItems].sort((a, b) => (b._score || 0) - (a._score || 0));
      applyDiversity(pool);
      for (const p of pool) {
        if (finalPicks.length >= maxItems) break;
        if (!seenHandles.has(p.handle)) { finalPicks.push(p); seenHandles.add(p.handle); }
      }
    } else if (onlyDamen) {
      // Strikt Damen + Unisex (Herren komplett blockiert)
      let pool = [...damenItems, ...unisexItems].sort((a, b) => (b._score || 0) - (a._score || 0));
      applyDiversity(pool);
      for (const p of pool) {
        if (finalPicks.length >= maxItems) break;
        if (!seenHandles.has(p.handle)) { finalPicks.push(p); seenHandles.add(p.handle); }
      }
    } else if (isMixed) {
      // 50/50 Split für gemischte Warenkörbe
      let poolDamen = [...damenItems, ...unisexItems].sort((a, b) => (b._score || 0) - (a._score || 0));
      let poolHerren = [...herrenItems, ...unisexItems].sort((a, b) => (b._score || 0) - (a._score || 0));
      
      applyDiversity(poolDamen);
      let countD = 0;
      for (const p of poolDamen) {
        if (countD >= (maxItems / 2) || finalPicks.length >= maxItems) break;
        if (!seenHandles.has(p.handle)) { finalPicks.push(p); seenHandles.add(p.handle); countD++; }
      }

      applyDiversity(poolHerren);
      let countH = 0;
      for (const p of poolHerren) {
        if (countH >= (maxItems / 2) || finalPicks.length >= maxItems) break;
        if (!seenHandles.has(p.handle)) { finalPicks.push(p); seenHandles.add(p.handle); countH++; }
      }

      // Auffüllen mit Rest, falls das Limit noch nicht erreicht ist
      for (const p of filtered) {
         if (finalPicks.length >= maxItems) break;
         if (!seenHandles.has(p.handle)) { finalPicks.push(p); seenHandles.add(p.handle); }
      }
    } else {
      // Unisex Cart (Default / Kein klares Geschlecht im Warenkorb)
      applyDiversity(filtered);
      for (const p of filtered) {
        if (finalPicks.length >= maxItems) break;
        if (!seenHandles.has(p.handle)) { finalPicks.push(p); seenHandles.add(p.handle); }
      }
    }
  }

  box.innerHTML = "";
  if (finalPicks.length === 0) {
    box.innerHTML = `<div style="padding:20px; text-align:center; color:#666; font-size:12px; grid-column:1/-1;">Keine passenden Produkte gefunden.</div>`;
    return;
  }

  const frag = document.createDocumentFragment();
  finalPicks.forEach(p => {
    const row = document.createElement("div"); row.className = "reco-item"; row.dataset.handle = p.handle;
    const imgObj = p.featured_image || p.image || (p.images && p.images[0]) || "";
    const imgStr = typeof imgObj === "object" ? (imgObj.src || "") : imgObj;
    const imgSrc = typeof imgUrl === "function" && imgStr ? imgUrl(imgStr, 200) : imgStr;

    const rawPrice = p.price || p.price_min || (p.variants && p.variants[0] ? p.variants[0].price : 0);
    let priceCents = 0;
    if (typeof rawPrice === "string") { const s = rawPrice.replace(/[^0-9.,]/g, ""); priceCents = (s.includes(".") || s.includes(",")) ? Math.round(parseFloat(s.replace(",", ".")) * 100) : parseInt(s, 10) || 0; }
    else if (typeof rawPrice === "number") { priceCents = rawPrice % 1 !== 0 ? Math.round(rawPrice * 100) : (rawPrice < 200 ? rawPrice * 100 : rawPrice); }
    
    const moneyFormatted = typeof moneyFmt === "function" ? moneyFmt(priceCents) : (priceCents/100).toFixed(2).replace(".",",")+" €";
    const btnHTML = (typeof QV_ENABLE !== "undefined" && QV_ENABLE) ? `<button class="rrx-quick-btn rrx-peel" type="button" data-handle="${p.handle}" aria-label="Schnellansicht"></button>` : "";
    const firstAvailVariant = p.variants && p.variants.find(v => v.available);
    const variantId = firstAvailVariant ? firstAvailVariant.id : "";

    row.innerHTML = `
       <div class="reco-img">
        <img src="${imgSrc}" alt="" loading="lazy" decoding="async">
        <div class="rrx-live-stars" data-handle="${p.handle}"></div>
      </div>
      <div class="reco-info">
        <div class="reco-ttl">${p.title}</div>
        <div class="reco-prc">${moneyFormatted}</div>
      </div>
      ${btnHTML}
      ${variantId ? `<button class="rrx-quick-add-btn" type="button" data-variant-id="${variantId}" aria-label="Direkt in den Warenkorb">
        <svg viewBox="0 0 24 24"><path d="M9 20a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-7.5-2h8.6a2 2 0 0 0 1.95-1.57l1.7-7.64a1 1 0 0 0-.96-1.21H5.78L5.35 4H2v2h2l3.6 13.59a2 2 0 0 0 1.9 1.41z"/></svg>
      </button>` : ""}
    `;
    
    const quickAddBtn = row.querySelector(".rrx-quick-add-btn");
    if (quickAddBtn) {
      const handleATC = async (ev) => {
        ev.preventDefault(); ev.stopPropagation();
        const vId = quickAddBtn.dataset.variantId;
        if (!vId) return;
        try { if (window.Shopify && window.Shopify.analytics) { window.Shopify.analytics.publish('rrx_drawer_context', { list_name: 'Warenkorb Empfehlungen', variant_id: vId }); } } catch(e) {}
        quickAddBtn.style.opacity = "0.6"; quickAddBtn.style.pointerEvents = "none";
        window._sre_active_ajax_list = "Warenkorb Empfehlungen";
        await fetch(getRoute("cart/add.js"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: vId, quantity: 1 }) }).catch(()=>{});
        if (typeof window.RRXCartDrawer !== "undefined") window.RRXCartDrawer.refresh(false);
        if (typeof window.RRXShowSuccessBanner === "function") window.RRXShowSuccessBanner();
      };
      quickAddBtn.addEventListener("click", handleATC);
      quickAddBtn.addEventListener("touchend", handleATC, { passive: false });
    }

    const btn = row.querySelector(".rrx-peel");
    if (btn) {
      const preloader = () => { if (typeof preloadQV === "function") preloadQV(p.handle); };
      btn.addEventListener("mouseenter", preloader, { once: true });
      btn.addEventListener("touchstart", preloader, { once: true, passive: true });
    }
    
    row.addEventListener("click", (ev) => {
      if (ev.target.closest('.rrx-quick-add-btn')) return; 
      if (ev.target.closest(".rrx-peel") || (typeof QV_ENABLE !== "undefined" && QV_ENABLE)) {
        ev.preventDefault(); ev.stopPropagation();
        if (typeof QV_CACHE !== "undefined" && typeof openQuickView === "function") {
          if (!QV_CACHE.has(p.handle) && typeof preloadQV === "function") preloadQV(p.handle);
          QV_CACHE.get(p.handle).then(prod => {
            openQuickView(prod, "Cart Recommendations");
            setTimeout(() => {
              const qv = document.getElementById("rrx-qv");
              if (!qv) return;
              const addBtn = qv.querySelector("[data-qv-add]");
              if (addBtn && !qv.querySelector('.qv-to-product-link')) {
                const linkBtn = document.createElement("a");
                linkBtn.className = "qv-to-product-link"; linkBtn.href = `/products/${p.handle}`;
                linkBtn.innerText = "Zur Produktseite"; linkBtn.style.display = "block"; linkBtn.style.marginTop = "12px"; linkBtn.style.fontSize = "14px"; linkBtn.style.fontWeight = "600"; linkBtn.style.textDecoration = "underline"; linkBtn.style.color = "var(--text-color, #4A5D53)"; linkBtn.style.cursor = "pointer";
                addBtn.parentNode.insertBefore(linkBtn, addBtn.nextSibling);
              }
            }, 10);
          }).catch(() => { window.location.href = `/products/${p.handle}`; });
        } else if (typeof openQuickView === "function") { 
          openQuickView(p.handle); 
        } else { 
          window.location.href = `/products/${p.handle}`; 
        }
      }
    });
    frag.appendChild(row);
  });
  
  box.appendChild(frag);
  box.querySelectorAll('.rrx-live-stars').forEach(container => { if(typeof loadLiveStars === 'function') loadLiveStars(container.dataset.handle, container); });
  if (typeof syncRecoCarousel === "function") syncRecoCarousel();
  
  // Trigger Scroll-Event um Pfeil-Sichtbarkeit direkt nach dem Rendern zu aktualisieren
  setTimeout(() => box.dispatchEvent(new Event('scroll')), 50);
}

async function renderRecs(cart) {
  const box = drawer.querySelector("[data-rrx-reco]");
  if (!box) return;

  if (!document.getElementById("rrx-reco-enhancements")) {
    const style = document.createElement("style");
    style.id = "rrx-reco-enhancements";
    style.textContent = `
      #rrx-cart-drawer .rrx-reco-wrap { 
        display: grid !important; 
        grid-template-columns: 44px minmax(0, 1fr) !important; 
        grid-template-areas: "title title" "tabs carousel" !important;
        gap: 12px 10px !important;
        max-width: 100% !important; box-sizing: border-box !important; overflow: hidden !important; 
      }
      
      #rrx-cart-drawer .rrx-right-h3 { grid-area: title; margin-bottom: 0 !important; }
      #rrx-cart-drawer .rrx-reco-tabs { grid-area: tabs; display: flex; flex-direction: column; gap: 8px; }
      #rrx-cart-drawer [data-rrx-reco] { grid-area: carousel; }
      
      #rrx-cart-drawer .rrx-reco-tab-btn {
        position: relative; /* Wichtig: Ankerpunkt für die Wellen */
        width: 44px; height: 44px; border-radius: 8px; padding: 0;
        background: var(--ac, #2E7D32) !important; color: #ffffff !important; 
        border: 1px solid rgba(0,0,0,0.1) !important;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15), 0 1px 3px rgba(0,0,0,0.1) !important;
        display: flex; align-items: center; justify-content: center; cursor: pointer; 
        transition: all 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
      }
      #rrx-cart-drawer .rrx-reco-tab-btn:hover { 
        background: #1A5E20 !important; 
        transform: translateY(-3px);
        box-shadow: 0 6px 16px rgba(0,0,0,0.2), 0 2px 4px rgba(0,0,0,0.1) !important; 
      }
      #rrx-cart-drawer .rrx-reco-tab-btn.is-active {
        background: #1A5E20 !important; 
        border-color: rgba(0,0,0,0.2) !important;
        box-shadow: inset 0 3px 6px rgba(0,0,0,0.25) !important;
        transform: translateY(1px);
      }
      #rrx-cart-drawer .rrx-reco-tab-btn svg { width: 22px; height: 22px; position: relative; z-index: 2; }
      
      /* 10-Sekunden Sequenz-Animation für die Kacheln */
      @keyframes rrxTabWavesSeq {
        0% { box-shadow: 0 0 0 0 rgba(46, 125, 50, 0.8), 0 0 0 0 rgba(46, 125, 50, 0.6), 0 0 0 0 rgba(46, 125, 50, 0.4); }
        15% { box-shadow: 0 0 0 4px rgba(46, 125, 50, 0), 0 0 0 8px rgba(46, 125, 50, 0), 0 0 0 12px rgba(46, 125, 50, 0); }
        100% { box-shadow: 0 0 0 4px rgba(46, 125, 50, 0), 0 0 0 8px rgba(46, 125, 50, 0), 0 0 0 12px rgba(46, 125, 50, 0); }
      }
      
      /* Allen inaktiven Kacheln die Animation zuweisen */
      #rrx-cart-drawer .rrx-reco-tab-btn:not(.is-active)::before {
        content: ""; position: absolute; inset: 0; border-radius: inherit; pointer-events: none;
        animation: rrxTabWavesSeq 10s cubic-bezier(0.16, 1, 0.3, 1) infinite; z-index: 1;
      }
      
      /* Verzögerung pro Kachel von oben nach unten (jeweils +1 Sekunde) */
      #rrx-cart-drawer .rrx-reco-tab-btn:nth-child(1):not(.is-active)::before { animation-delay: 0s; }
      #rrx-cart-drawer .rrx-reco-tab-btn:nth-child(2):not(.is-active)::before { animation-delay: 1s; }
      #rrx-cart-drawer .rrx-reco-tab-btn:nth-child(3):not(.is-active)::before { animation-delay: 2s; }
      #rrx-cart-drawer .rrx-reco-tab-btn:nth-child(4):not(.is-active)::before { animation-delay: 3s; }
      #rrx-cart-drawer .rrx-reco-tab-btn:nth-child(5):not(.is-active)::before { animation-delay: 4s; }

      #rrx-cart-drawer .reco-item .rrx-quick-btn, #rrx-cart-drawer .reco-item .rrx-peel { display: none !important; }
      #rrx-cart-drawer .reco-item { position: relative !important; cursor: pointer !important; }
      #rrx-cart-drawer .reco-img { position: static !important; } 
      #rrx-cart-drawer .reco-item .rrx-rating-wrapper { top: auto !important; left: auto !important; flex-direction: column !important; }
      #rrx-cart-drawer .reco-item .rrx-bubble-stars { flex-direction: column-reverse !important; padding: 6px 4px 4px 4px !important; }
      #rrx-cart-drawer .reco-item .rrx-bubble-count { margin-top: 2px !important; margin-left: 0 !important; }
      #rrx-cart-drawer .reco-ttl, #rrx-cart-drawer .reco-prc, #rrx-cart-drawer .reco-item .rrx-review-count-text { color: var(--text-color, #1a1a1a) !important; }

      #rrx-cart-drawer .rrx-totalbox, #rrx-cart-drawer .rrx-cart-badges { background: transparent !important; border: none !important; box-shadow: none !important; padding-left: 0 !important; padding-right: 0 !important; }
      #rrx-cart-drawer .rrx-totalbox { padding-top: 0 !important; margin-top: 10px !important; margin-bottom: 20px !important; }
      #rrx-cart-drawer .rrx-cart-badges { padding-bottom: 0 !important; margin-top: 16px !important; }
      
      /* =========================================
         DESKTOP CSS (Ab 761px)
         ========================================= */
      @media (min-width: 761px) {
        #rrx-cart-drawer .rrx-reco-wrap, #rrx-cart-drawer .rrx-left { background-color: rgba(74, 93, 83, 0.05) !important; border-radius: 12px !important; padding: 20px !important; box-sizing: border-box !important; }
        
        /* Scroll-Indikator Pfeil (Breiter & Grün) */
        #rrx-cart-drawer .rrx-reco-scroll-arrow {
          grid-area: carousel;
          justify-self: center;
          align-self: end;
          margin-bottom: 12px; /* Positiver Wert, damit 'overflow: hidden' den Pfeil nicht abschneidet */
          width: 72px; /* Breiter (Pillenform) */
          height: 32px;
          background: #56675D; /* Grün wie Cart Button */
          border-radius: 16px; /* Symmetrische Rundung */
          box-shadow: 0 4px 12px rgba(0,0,0,0.15), 0 0 0 1px rgba(0,0,0,0.05);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
          cursor: pointer;
          color: #ffffff; /* Weißes Icon */
          transition: opacity 0.25s ease, transform 0.2s ease, filter 0.2s ease;
        }
        
        #rrx-cart-drawer .rrx-reco-scroll-arrow:hover {
          transform: translateY(4px);
          filter: brightness(1.15); /* Heller beim Hover statt Farbwechsel */
        }
        
        #rrx-cart-drawer .rrx-reco-scroll-arrow svg {
          width: 20px;
          height: 20px;
        }

        /* Vertikales Scroll-Karussell (Desktop) */
        #rrx-cart-drawer [data-rrx-reco] { 
          background-color: transparent !important; 
          border-radius: 0 !important; 
          display: flex !important; 
          flex-direction: column !important; 
          gap: 12px !important; 
          overflow-y: auto !important; 
          max-height: 556px !important; /* 4 Kacheln à 130px + 3 Gaps à 12px = 556px */
          padding: 0 6px 0 0 !important; /* Rechter Abstand für die Scrollbar */
          scrollbar-width: thin;
          scrollbar-color: rgba(86, 103, 93, 0.4) transparent;
        }
        #rrx-cart-drawer [data-rrx-reco]::-webkit-scrollbar { width: 6px; }
        #rrx-cart-drawer [data-rrx-reco]::-webkit-scrollbar-track { background: transparent; }
        #rrx-cart-drawer [data-rrx-reco]::-webkit-scrollbar-thumb { background: rgba(86, 103, 93, 0.4); border-radius: 10px; }
        
        #rrx-cart-drawer .rrx-right-h3, #rrx-cart-drawer .rrx-reco-title, #rrx-cart-drawer .rrx-left-h3 { display: block !important; font-size: 1.1rem !important; font-weight: 700 !important; margin-top: 0 !important; margin-bottom: 20px !important; line-height: 1.2 !important; color: var(--heading-color, var(--text-color, #1a1a1a)) !important; letter-spacing: normal !important; }
        
        /* Kacheln auf exakte Höhe zwingen für 4er Grid */
        #rrx-cart-drawer .reco-item { background: #ffffff !important; border-radius: 10px !important; box-shadow: 0 4px 12px rgba(0,0,0,0.04) !important; border: 1px solid rgba(0,0,0,0.03) !important; flex: 0 0 130px !important; height: 130px !important; margin: 0 !important; padding: 12px !important; transition: transform 0.2s ease, box-shadow 0.2s ease !important; display: grid !important; grid-template-columns: 110px 1fr !important; gap: 24px !important; align-items: center !important; overflow: hidden !important; }
        
        #rrx-cart-drawer .rrx-item { background: #ffffff !important; border-radius: 10px !important; box-shadow: 0 4px 12px rgba(0,0,0,0.04) !important; border: 1px solid rgba(0,0,0,0.03) !important; transition: transform 0.2s ease, box-shadow 0.2s ease !important; }
        
        #rrx-cart-drawer .reco-item:hover, #rrx-cart-drawer .rrx-item:hover, #rrx-cart-drawer .rrx-recent-grid a:hover { transform: translateY(-2px) !important; box-shadow: 0 6px 16px rgba(0,0,0,0.08) !important; }
        #rrx-cart-drawer .reco-img { width: 110px !important; height: 110px !important; display: flex !important; align-items: center !important; justify-content: center !important; margin-left: 0 !important; }
        #rrx-cart-drawer .reco-img img { width: 100% !important; height: 100% !important; object-fit: contain !important; background: transparent !important; mix-blend-mode: darken !important; filter: none !important; }
        #rrx-cart-drawer .reco-ttl { font-size: 1.05rem !important; }
        #rrx-cart-drawer .reco-item .rrx-rating-wrapper { bottom: auto !important; top: 50% !important; right: 16px !important; transform: translateY(-50%) scale(0.9) !important; transform-origin: center right !important; }
        #rrx-cart-drawer .reco-item .rrx-rating-wrapper:hover { transform: translateY(-50%) scale(0.95) !important; }
        #rrx-cart-drawer .rrx-trust { margin-top: 16px !important; margin-bottom: 12px !important; }
      }

      /* =========================================
         MOBILE CSS (Bis 760px)
         ========================================= */
      @media (max-width: 760px) {
        /* Pfeil auf Mobile hart blockieren (muss im Mobile-Block stehen!) */
        #rrx-cart-drawer .rrx-reco-scroll-arrow { 
          display: none !important; 
        }

        #rrx-cart-drawer .rrx-reco-wrap { 
          grid-template-columns: 38px minmax(0, 1fr) !important;
          margin-top: 16px !important; margin-bottom: 16px !important; padding: 12px 0 12px 12px !important; background-color: rgba(74, 93, 83, 0.05) !important; border-radius: 8px !important; width: 100% !important; box-sizing: border-box !important; gap: 8px !important;
        }
        .rrx-reco-tab-btn { width: 38px; height: 38px; }
        .rrx-reco-tab-btn svg { width: 18px; height: 18px; }
        #rrx-cart-drawer .rrx-left { min-width: 0 !important; max-width: 100% !important; }
        #rrx-cart-drawer .rrx-right-h3 { display: block !important; font-size: 1.1rem !important; font-weight: 700 !important; margin: 0 !important; color: var(--heading-color, var(--text-color, #1a1a1a)) !important; }
        #rrx-cart-drawer [data-rrx-reco][data-carousel="1"] { display: flex !important; flex-wrap: nowrap !important; overflow-x: auto !important; -webkit-overflow-scrolling: touch !important; scroll-snap-type: x mandatory !important; scrollbar-width: none !important; gap: 8px !important; padding-bottom: 4px !important; padding-right: 12px !important; box-sizing: border-box !important; width: 100% !important; }
        #rrx-cart-drawer [data-rrx-reco][data-carousel="1"]::-webkit-scrollbar { display: none !important; }
        #rrx-cart-drawer .rrx-item { background: #ffffff !important; border-radius: 12px !important; box-shadow: 0 4px 12px rgba(0,0,0,0.08), 0 1px 3px rgba(0,0,0,0.05) !important; border: 1px solid rgba(0,0,0,0.06) !important; }
        #rrx-cart-drawer .rrx-checkout-wrap { background-color: rgba(74, 93, 83, 0.05) !important; border-radius: 12px !important; padding: 20px 16px !important; margin-top: 16px !important; margin-bottom: 16px !important; box-sizing: border-box !important; }
        #rrx-cart-drawer [data-rrx-reco][data-carousel="1"] .reco-item { scroll-snap-align: start !important; flex: 0 0 calc(75% - 12px) !important; max-width: calc(75% - 12px) !important; background:rgb(255, 255, 255) !important; padding: 6px !important; border-radius: 8px !important; box-shadow: 0 4px 10px rgba(81, 165, 53, 0.05) !important; border: 1px solid rgba(0,0,0,0.03) !important; box-sizing: border-box !important; display: flex !important; flex-direction: column !important; align-items: center !important; }
        #rrx-cart-drawer .reco-img { width: 100% !important; height: auto !important; aspect-ratio: 1 / 1 !important; display: flex !important; align-items: center !important; justify-content: center !important; margin: 0 0 6px 0 !important; position: relative !important; }
        #rrx-cart-drawer .reco-img img { width: 100% !important; height: 100% !important; object-fit: contain !important; background: transparent !important; mix-blend-mode: darken !important; }
        #rrx-cart-drawer .reco-info { text-align: center !important; width: 100% !important; padding: 0 2px !important; display: flex !important; flex-direction: column !important; justify-content: flex-end !important; flex-grow: 1 !important; }
        #rrx-cart-drawer .reco-ttl { font-size: 11px !important; line-height: 1.1 !important; margin-bottom: 2px !important; font-weight: 500 !important; display: -webkit-box !important; -webkit-line-clamp: 2 !important; -webkit-box-orient: vertical !important; overflow: hidden !important; text-overflow: ellipsis !important; }
        #rrx-cart-drawer .reco-prc { font-size: 12px !important; font-weight: 700 !important; }
        #rrx-cart-drawer .reco-item .rrx-rating-wrapper { bottom: 0 !important; top: auto !important; right: auto !important; left: 50% !important; transform: translateX(-50%) scale(1.2) !important; transform-origin: bottom center !important; flex-direction: row !important; }
        #rrx-cart-drawer .reco-item .rrx-rating-wrapper:hover { transform: translateX(-50%) scale(0.95) !important; }
        #rrx-cart-drawer .reco-item .rrx-bubble-stars { flex-direction: row !important; padding: 4px 6px !important; }
        #rrx-cart-drawer .reco-item .rrx-bubble-count { margin-top: 0 !important; margin-left: 2px !important; }
      }

      @keyframes rrxBtnWaves {
        0% { box-shadow: 0 0 0 0 rgba(46, 125, 50, 0.8), 0 0 0 0 rgba(46, 125, 50, 0.6), 0 0 0 0 rgba(46, 125, 50, 0.4); }
        100% { box-shadow: 0 0 0 4px rgba(46, 125, 50, 0), 0 0 0 8px rgba(46, 125, 50, 0), 0 0 0 12px rgba(46, 125, 50, 0); }
      }
      #rrx-cart-drawer .rrx-quick-add-btn { position: absolute; bottom: 16px; right: 52px; width: 34px; height: 34px; border-radius: 50% !important; background: var(--ac, #2E7D32) !important; color: #fff !important; border: none !important; display: flex !important; align-items: center !important; justify-content: center !important; cursor: pointer !important; z-index: 10 !important; transition: background 0.2s ease, transform 0.2s ease !important; padding: 0 !important; }
      #rrx-cart-drawer .rrx-quick-add-btn::before { content: "" !important; position: absolute !important; inset: 0 !important; border-radius: inherit !important; pointer-events: none !important; animation: rrxBtnWaves 2s cubic-bezier(0.16, 1, 0.3, 1) infinite !important; z-index: -1 !important; }
      #rrx-cart-drawer .rrx-quick-add-btn:hover { background: #1A5E20 !important; transform: scale(1.1) !important; }
      #rrx-cart-drawer .rrx-quick-add-btn:hover::before { animation: none !important; }
      #rrx-cart-drawer .rrx-quick-add-btn svg { width: 16px !important; height: 16px !important; fill: #ffffff !important; stroke: none !important; }
      @media (max-width: 760px) { #rrx-cart-drawer .rrx-quick-add-btn { width: 30px; height: 30px; bottom: 6px; right: 6px; } #rrx-cart-drawer .rrx-quick-add-btn svg { width: 14px !important; height: 14px !important; } }
    `;
    document.head.appendChild(style);
  }

  const validItems = cart.items ? cart.items.filter(Boolean) : [];
  const currentCacheKey = validItems.length > 0 ? validItems.map(i => i.handle).sort().join(",") : "empty_cart_reco";
  if (box.getAttribute('data-cart-key') === currentCacheKey && window.__rrxRecoCandidates) return; 

  const cartHandles = [...new Set(validItems.map(i => i.handle))];
  let cartProds = [];
  try { cartProds = await Promise.all(cartHandles.map(h => fetch(getRoute(`products/${h}.js`)).then(r => r.ok ? r.json() : null).catch(() => null))); } catch(e) {}
  
  const cartTags = cartProds.filter(Boolean).flatMap(p => p.tags || []).map(t => String(t).toLowerCase().trim());
  const coreMotifs = ['berg', 'berge', 'wald', 'hund', 'fahrrad', 'wandern', 'getränk'];
  const activeMotifs = coreMotifs.filter(m => cartTags.some(t => t.includes(m)));
  window.__rrxActiveMotifs = activeMotifs;

  const isCartHerren = cartTags.some(t => t === 'herren' || t === 'männer' || t === 'papa') || validItems.some(i => (i.product_title||"").toLowerCase().includes('herren') || (i.product_title||"").toLowerCase().includes('männer'));
  const isCartDamen = cartTags.some(t => t === 'damen' || t === 'frauen' || t === 'mama') || validItems.some(i => (i.product_title||"").toLowerCase().includes('damen') || (i.product_title||"").toLowerCase().includes('frauen'));
  let cartGender = "unisex";
  if (isCartHerren && !isCartDamen) cartGender = "herren";
  if (isCartDamen && !isCartHerren) cartGender = "damen";
  window.__rrxCartGender = cartGender; 
  window.__rrxIsCartHerren = isCartHerren; // Explizite Flags für Split-Logik speichern
  window.__rrxIsCartDamen = isCartDamen;

  const collectionHandles = new Set(['accessoires', 'alle-accessoires', 't-shirts', 'tassen', 'armbaender', 'geschenke', 'schluesselanhaenger']);
  activeMotifs.forEach(m => collectionHandles.add(m.replace(/[^a-z0-9]+/g, '-')));
  const endpoints = Array.from(collectionHandles).map(h => `/collections/${h}/products.json?limit=36`);
  endpoints.push(`/products.json?limit=36`);

  let candidates = [];
  await Promise.all(endpoints.map(async url => {
    try { const r = await fetch(url); if (r.ok) { const text = await r.text(); try { const data = JSON.parse(text); if (data.products) candidates.push(...data.products); } catch(e) {} } } catch(e) {}
  }));

  const uniqueMap = new Map();
  const inCart = new Set(validItems.map(i => i.handle));
  candidates.forEach(c => { 
    const isAvailable = c.variants && c.variants.some(v => v.available);
    if (c && c.handle && !inCart.has(c.handle) && !uniqueMap.has(c.handle) && isAvailable) { 
      uniqueMap.set(c.handle, c); 
    } 
  });
  
  let scoredCandidates = Array.from(uniqueMap.values()).map(p => {
    const pTags = Array.isArray(p.tags) ? p.tags.map(t => String(t).toLowerCase().trim()) : [];
    const titleType = `${p.type || p.product_type || ""} ${p.title || ""}`.toLowerCase();
    
    const isHerrenTag = pTags.some(t => t === 'herren' || t === 'männer' || t === 'papa') || titleType.includes('herren') || titleType.includes('männer');
    const isDamenTag = pTags.some(t => t === 'damen' || t === 'frauen' || t === 'mama') || titleType.includes('damen') || titleType.includes('frauen');
    const isBestseller = pTags.some(t => t === 'bestseller');

    p._score = 0;
    p._matchedMotifs = [];
    
    // Bestseller-Garantie: Unschlagbarer Boost (10.000 Punkte)
    if (isBestseller) {
      p._score += 10000;
    }

    activeMotifs.forEach(m => { 
      if (pTags.some(t => t.includes(m)) || titleType.includes(m)) { 
        p._score += 100; 
        p._matchedMotifs.push(m);
      } 
    });
    
    // Aggressives Gender-Scoring für maximale Relevanz in allen Tabs (z.B. Socken)
    // Gender überschreibt nicht den Bestseller-Status, aber sortiert Bestseller untereinander korrekt
    if (cartGender === "herren") {
        if (isHerrenTag) p._score += 500; 
        if (isDamenTag && !isHerrenTag) p._score -= 5000; // Damen-Sachen komplett begraben
    } else if (cartGender === "damen") {
        if (isDamenTag) p._score += 500; 
        if (isHerrenTag && !isDamenTag) p._score -= 5000; // Herren-Sachen komplett begraben
    }
    
    return p;
  });

  window.__rrxRecoCandidates = scoredCandidates;
  box.setAttribute('data-cart-key', currentCacheKey);

  const h3Title = drawer.querySelector('.rrx-right-h3');
  if (h3Title) { h3Title.style.display = 'block'; }

  ensureRecoWrap();
  
  let activeTab = 'socken';
  const activeTabBtn = drawer.querySelector('.rrx-reco-tab-btn.is-active');
  if (activeTabBtn) activeTab = activeTabBtn.dataset.tab;
  
  renderRecoItemsUI(window.__rrxRecoCandidates, activeTab);
}

  async function refresh(openedByUi){
    const cart = await getCart();
    renderItems(cart);
    await renderTotals(cart);
    const subtotal = cart.total_price || 0;
    const itemCount = cart.item_count || 0;
    const shippingCents = itemCount === 0 ? 0 : await estimateShippingCents(subtotal);
    await renderRecs(cart);
    LAST_CART = cart;
    window.LAST_CART = cart;
    initExpressButtonsSafely();
    fixExpressVisibility();
    ensureExpressObserver();
    document.dispatchEvent(new CustomEvent('cart:updated', { 
      bubbles: true, 
      detail: { cart: cart } 
    }));
    if (drawer.getAttribute("aria-hidden") === "false"){
      dl("view_cart", {
        currency: CURRENCY,
        value: (cart.total_price || 0) / 100,
        items: mapItems(cart),
        item_count: cart.item_count || 0,
        cart_token: cart.token || undefined
      });
      if (openedByUi) dl("rrx_cart_drawer_open", { source: "ui" });
    }
  }

  window.__RRX_BEGIN_CHECKOUT_ONCE__ = (() => {
    let lastTs = 0;                     
    return function () {
      const now = Date.now();
      if (now - lastTs < 2500) return;   
      lastTs = now;

      try {
        if (META_PIXEL_BRIDGE_ENABLED && typeof window.fbq === "function") {
          const icEventID = MPX.id(); 
          window.fbq("track", "InitiateCheckout", {}, { eventID: icEventID });
        }
      } catch (_) {}
    };
  })();

  drawer.addEventListener('submit', (ev) => {
    const form = ev.target.closest('form[data-rrx="checkout-form"]');
    if (!form) return;
    window.__RRX_BEGIN_CHECKOUT_ONCE__?.();
  }, true);

  document.addEventListener("DOMContentLoaded",()=>{
    try{
      const meta = document.querySelector('meta[property="og:url"]')?.content || location.pathname;
      const m    = meta.match(/\/products\/([^\/?#]+)/);
      if (m){
        const h = m[1];
        const k = "rrx_recent_handles";
        const arr = (localStorage.getItem(k)||"").split(",").filter(Boolean);
        arr.push(h);
        localStorage.setItem(k, arr.join(","));
      }
    }catch(_){}
  });
// --- PANZER-MODUS: Mobile Checkout-Box (Gruppiert den unteren Bereich) ---
  function wrapCheckoutArea() {
    const totalBox = drawer.querySelector('.rrx-totalbox');
    if (totalBox && !drawer.querySelector('.rrx-checkout-wrap')) {
      const wrap = document.createElement('div');
      wrap.className = 'rrx-checkout-wrap';
      totalBox.parentNode.insertBefore(wrap, totalBox);
      
      // Verschiebt die Totalbox und alles danach (Buttons, Badges) in den neuen Container
      let el = totalBox;
      while (el) {
        let next = el.nextSibling;
        wrap.appendChild(el);
        el = next;
      }
    }
  }
  wrapCheckoutArea();
  if (!IN_EDITOR){ refresh(false); }

  function centerZoomedImage(scroll) {
    if (scroll.scrollWidth > scroll.clientWidth) {
      scroll.scrollLeft = (scroll.scrollWidth - scroll.clientWidth) / 2;
    }
    if (scroll.scrollHeight > scroll.clientHeight) {
      scroll.scrollTop = (scroll.scrollHeight - scroll.clientHeight) / 2;
    }
  }

  function ensureZoomOverlay(){
    if (byId("rrx-qv-zoom")) return;
    const z = document.createElement("div");
    z.id = "rrx-qv-zoom";
    z.setAttribute("aria-hidden","true");
    
    z.innerHTML = `
      <div class="zoom-bd">
        <button class="zoom-x" aria-label="Schließen" title="Schließen">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>
        </button>
        <div class="zoom-scroll">
          <img class="zoom-img" alt="">
        </div>
      </div>
    `;
    document.body.appendChild(z);
    
    const scroll = z.querySelector(".zoom-scroll");
    const img    = z.querySelector(".zoom-img");
    const close  = z.querySelector(".zoom-x");

    function resetZoomState(){
      if(!img) return;
      img.style.width = "";
      img.style.maxWidth = "";
      img.style.maxHeight = "";
      img.style.transform = "";
      if(scroll) {
        scroll.classList.remove("is-zoomed");
        scroll.scrollTop = 0;
        scroll.scrollLeft = 0;
      }
    }

    close?.addEventListener("click", closeZoom);
    
    z.addEventListener("click", (e) => {
        if (e.target === z || e.target.closest(".zoom-bd") === z.querySelector(".zoom-bd")) {
            if (e.target !== img && !e.target.closest(".zoom-x")) {
                closeZoom();
            }
        }
    });

    img?.addEventListener("click", (e) => {
      e.stopPropagation();
      if (!scroll.classList.contains("is-zoomed")) {
         scroll.classList.add("is-zoomed");
         centerZoomedImage(scroll); 
      } else {
        resetZoomState();
      }
    });

    let startDist = 0;
    let startWidth = 0;
    let isPinching = false;

    img.addEventListener("touchstart", (e) => {
      if (e.touches.length === 2) {
        e.preventDefault(); 
        e.stopPropagation();

        const dx = e.touches[0].pageX - e.touches[1].pageX;
        const dy = e.touches[0].pageY - e.touches[1].pageY;
        startDist = Math.hypot(dx, dy);
        startWidth = img.getBoundingClientRect().width;
        isPinching = true;
        
        scroll.classList.add("is-zoomed");
      }
    }, {passive: false});

    img.addEventListener("touchmove", (e) => {
      if (isPinching && e.touches.length === 2) {
        e.preventDefault();
        e.stopPropagation();

        const dx = e.touches[0].pageX - e.touches[1].pageX;
        const dy = e.touches[0].pageY - e.touches[1].pageY;
        const dist = Math.hypot(dx, dy);

        if (startDist > 0 && dist > 0) {
          const ratio = dist / startDist;
          let newW = startWidth * ratio;
          
          const MIN_ZOOM_W = startWidth * 0.95;
          newW = Math.max(MIN_ZOOM_W, newW);
          newW = Math.min(5000, newW); 

          img.style.maxWidth = "none";
          img.style.maxHeight = "none";
          img.style.width = newW + "px";

          centerZoomedImage(scroll);
        }
      } 
    }, {passive: false});

    img.addEventListener("touchend", () => {
      if (isPinching) {
          isPinching = false;
          if (img.getBoundingClientRect().width < startWidth * 0.98) {
              resetZoomState();
          }
      }
      startDist = 0;
      startWidth = 0;
    });

    scroll.addEventListener('wheel', (e) => {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
        const delta = e.deltaY * -0.001; 
        
        let currentW = img.getBoundingClientRect().width;
        if (!currentW || currentW < 100) currentW = window.innerWidth;
        
        const initialFitW = img.clientWidth; 
        let newW = currentW * (1 + delta);

        if (newW < initialFitW * 0.95 && delta < 0) {
            resetZoomState();
            return;
        }

        newW = Math.min(5000, newW); 
        
        scroll.classList.add("is-zoomed");
        img.style.maxWidth = "none";
        img.style.maxHeight = "none";
        img.style.width = newW + "px";

        centerZoomedImage(scroll);
      }
    }, {passive: false});
  }

  function openZoom(src){
    const z = byId("rrx-qv-zoom"); if (!z) return;
    const img = z.querySelector(".zoom-img");
    const scroll = z.querySelector(".zoom-scroll");
    
    if (img) {
      img.style.width = "";
      img.style.maxWidth = "";
      img.style.maxHeight = "";
      img.style.transform = "";
    }
    if (scroll) {
      scroll.classList.remove("is-zoomed");
      scroll.scrollTop = 0; scroll.scrollLeft = 0;
    }
    
    img.src = src || "";
    z.setAttribute("aria-hidden","false");
    document.documentElement.style.setProperty("--rrx-zoom-open","1");
  }

  function closeZoom(){
    const z = byId("rrx-qv-zoom"); if (!z) return;
    z.setAttribute("aria-hidden","true");
    document.documentElement.style.removeProperty("--rrx-zoom-open");
  }

  try{
    const s = document.createElement("style");
    s.textContent = `
      #rrx-qv .rrx-qv-card{ position:relative; display:grid; grid-template-rows:auto 1fr; width:min(740px,92vw); max-height:86vh; overflow:hidden; }
      #rrx-qv .rrx-qv-body{ overflow-y:auto; overflow-x:hidden; padding-inline:0; padding-bottom:8px; box-sizing:border-box; -ms-overflow-style: none; scrollbar-width: none; }
      #rrx-qv .rrx-qv-body::-webkit-scrollbar { display: none; width: 0; height: 0; }
      #rrx-qv .rrx-qv-head{ display:grid; grid-template-columns:1fr; gap:12px; place-items:center; text-align:center; margin-bottom:8px; }
      #rrx-qv .qv-pic{ position:relative; display:inline-block; }
      #rrx-qv .qv-img{
        width:auto; height:auto; object-fit:contain; display:block; background:#fff; border-radius:12px;
        margin-inline:auto; max-width:min(92%, 640px); max-height:clamp(220px, var(--qv-img, 420px), 60vh);
      }
      @media (max-width:760px){
        #rrx-qv .rrx-qv-card { max-height: 92vh; }
        #rrx-qv .qv-img{ max-width: 75%; max-height: min(28vh, 240px); }
        #rrx-qv .rrx-qv-head{ gap: 4px; margin-bottom: 2px; }
        #rrx-qv .qv-opt-label { margin-bottom: 6px !important; font-size: 13px !important; }
        #rrx-qv .qv-opt-selected-val { font-size: 14px !important; }
        #rrx-qv .qv-opt{ margin-top: 4px; }
        #rrx-qv .qv-opt--color .qv-opt-btn{ width: 30px; height: 30px; }
        #rrx-qv .qv-opt--size .qv-opt-btn{ min-width: 40px; height: 40px; padding: 0 8px; font-size: 13px; }
        #rrx-qv .qv-actions{ margin-top: 6px; max-width: 100%; }
        #rrx-qv .qv-actions > *{ max-width: 100%; }
        #rrx-qv .qv-actions .rrx-btn--xl { width: 100%; max-width: 100%; min-height: 44px; font-size: 14px; }
        #rrx-qv .qv-to-product-link { margin-top: 8px !important; font-size: 13px !important; }
      }

      /* --- NEU: QUICK-VIEW CSS (Korrektes Targeting auf #rrx-qv) --- */
      #rrx-qv .qv-opt-values::-webkit-scrollbar { display: none; width: 0; height: 0; }
      
      #rrx-qv .qv-opt-btn{
        display:inline-flex; justify-content:center; align-items:center;
        background:#ffffff; cursor:pointer;
        border: 1px solid #e3e6ea;
        color: var(--text-color, #2f2f2f);
        transition: all 0.15s ease;
      }
      #rrx-qv .qv-opt-btn:hover{ 
        border-color: #56675D; 
      }

      #rrx-qv .qv-opt--size .qv-opt-btn {
        min-width: 48px; height: 44px; padding: 0 12px; border-radius: 4px; font-weight: 600; font-size: 14px;
      }
      #rrx-qv .qv-opt--size .qv-opt-btn.is-active {
        background-color: #56675D !important;
        color: #ffffff !important;
        border-color: #56675D !important;
        box-shadow: none;
      }
      #rrx-qv .qv-opt--color .qv-opt-btn {
        width: 36px; height: 36px; padding: 0; border-radius: 50%;
        border: 1px solid rgba(0,0,0,0.1); background-color: var(--swatch);
        box-shadow: inset 0 0 0 1px rgba(0,0,0,0.05);
      }
      #rrx-qv .qv-opt--color .qv-opt-btn.is-active {
        border-color: transparent; 
        box-shadow: 0 0 0 2px #fff, 0 0 0 4px #56675D !important;
      }

      #rrx-qv .qv-actions .rrx-btn--xl {
        background: #4A5D53 !important; color: #ffffff !important; border-radius: 2px !important;
        text-transform: uppercase; letter-spacing: 0.05em; font-weight: 700; border: 1px solid #4A5D53;
      }
      #rrx-qv .qv-actions .rrx-btn--xl:hover {
        filter: brightness(1.1); box-shadow: 0 5px 15px rgba(0,0,0,0.15); transform: translateY(-1px);
      }
      #rrx-qv .qv-actions .rrx-btn--xl[disabled] {
        opacity: 0.6; cursor: not-allowed; filter: none; transform: none; box-shadow: none;
      }

      #rrx-qv .rrx-qv-eye{
        position:absolute; right:10px; bottom:10px; inline-size: 44px; block-size: 44px;
        border-radius:999px; background:#fff; border:1px solid #e3e6ea; display:grid; place-items:center; overflow:hidden; isolation:isolate;
        box-shadow:0 6px 18px rgba(0,0,0,.10); cursor:pointer; z-index:4;
      }
      #rrx-qv .rrx-qv-eye > span{ position:relative; width:64%; height:40%; border-radius:999px / 70%; background:#111; }
      #rrx-qv .rrx-qv-eye > span::before{ content:""; position:absolute; left:50%; top:50%; width:58%; height:58%; transform:translate(-50%,-50%); border-radius:50%; background:#fff; }
      #rrx-qv .rrx-qv-eye > span::after{ content:""; position:absolute; left:50%; top:50%; width:30%; height:30%; transform:translate(-50%,-50%); border-radius:50%; background:#111; }
      
      /* NEU: Größentabellen Button (Maßband) */
      #rrx-qv .rrx-qv-size {
        position:absolute; left:10px; bottom:10px; inline-size: 44px; block-size: 44px;
        border-radius:999px; background:#fff; border:1px solid #e3e6ea; display:grid; place-items:center; overflow:hidden; isolation:isolate;
        box-shadow:0 6px 18px rgba(0,0,0,.10); cursor:pointer; z-index:20 !important; /* Erhöht, um Overlaps zu verhindern */
        color: #56675D; transition: transform 0.2s ease;
        pointer-events: auto !important; /* Erzwingt physische Klickbarkeit */
      }
      #rrx-qv .rrx-qv-size:hover { transform: scale(1.05); }

      /* Icon-Größe des Maßbandes exakt an die Lupe anpassen */
      #rrx-qv .rrx-qv-size svg {
        width: 20px !important;
        height: 20px !important;
      }

      @media (max-width:760px){ 
        /* FALSCHEN SELECTOR KORRIGIERT: #rrx-qv statt #rrx-cart-drawer */
        #rrx-qv .rrx-qv-eye, #rrx-qv .rrx-qv-size { 
          inline-size: 40px !important; 
          block-size: 40px !important; 
        }
        #rrx-qv .rrx-qv-size { left: 8px; bottom: 8px; }
        #rrx-qv .rrx-qv-eye { right: 8px; bottom: 8px; }
      }
      #rrx-qv-zoom{ position:fixed; inset:0; z-index:1000003; display:none; }
      #rrx-qv-zoom[aria-hidden="false"]{ display:block; }
      #rrx-qv-zoom .zoom-bd{ position:absolute; inset:0; background:rgba(0,0,0,.92); display:flex; align-items:center; justify-content:center; }
      #rrx-qv-zoom .zoom-scroll{ display:flex; align-items:center; justify-content:center; overflow:hidden; touch-action: pan-x pan-y; -webkit-overflow-scrolling: touch; }
      #rrx-qv-zoom .zoom-scroll.is-zoomed{ display:block; overflow:auto; cursor:zoom-out; width: 100%; height: 100%; }
      #rrx-qv-zoom .zoom-img{ max-width:min(94vw,1600px); max-height:90vh; width:auto; height:auto; object-fit:contain; border-radius:4px; background:#fff; cursor:zoom-in; transition:opacity .15s ease; will-change: width, transform; transform-origin: 0 0; }
      #rrx-qv-zoom .zoom-scroll.is-zoomed .zoom-img{ max-width:none; max-height:none; margin: auto; cursor:zoom-out; }
      #rrx-qv-zoom .zoom-x{ position:absolute; right:20px; top:20px; width:44px; height:44px; background:#fff; border-radius:50%; border:none; display:grid; place-items:center; cursor:pointer; box-shadow:0 4px 12px rgba(0,0,0,0.3); z-index:2000000; }
      #rrx-qv-zoom .zoom-x:hover{ transform:scale(1.1); }
      #rrx-qv-zoom .zoom-x:active{ transform:scale(0.95); }

      #rrx-cart-drawer .rrx-reco-wrap{ position:relative; }
      #rrx-qv .qv-title, #rrx-qv .qv-price, #rrx-cart-drawer .qv-title, #rrx-cart-drawer .qv-price, #rrx-cart-drawer [data-product-price], #rrx-cart-drawer .price{ display:none !important; }
      .rrx-express{ margin-top:10px; }
      .rrx-express .shopify-payment-button{ width:100%; }
      .rrx-express .shopify-payment-button__button{ width:100%; border-radius:999px; min-height:48px; }
      
      @media (max-width:1024px){
        cart-notification-drawer, cart-notification, #CartNotification, .cart-notification{
          position: fixed !important; left: 12px !important; right: auto !important; bottom: 12px !important; transform: none !important; max-width: 420px !important; width: calc(100vw - 24px) !important; z-index: 1000000;
        }
      }
      html.rrx-cart-open cart-notification-drawer, html.rrx-cart-open cart-notification, html.rrx-cart-open #CartNotification, html.rrx-cart-open .cart-notification{
        display: none !important;
      }

      :where(.product-form, .product-form__input, .variant-input, .product-options, .swatch) input[disabled] + label,
      :where(.product-form, .product-form__input, .variant-input, .product-options, .swatch) label[aria-disabled="true"],
      #rrx-qv .qv-opt--size .qv-opt-btn[disabled],
      #rrx-qv .qv-opt--size .qv-opt-btn[aria-disabled="true"],
      #rrx-qv .qv-opt--size .qv-opt-btn.soldout{
        text-decoration: none !important;
      }
      #rrx-qv .qv-opt--size .qv-opt-btn.soldout::after{
        content:""; position:absolute; left:50%; top:50%; width:70%; height:2px; background: currentColor; transform:translate(-50%,-50%) rotate(-20deg); pointer-events:none;
      }

      #rrx-cart-drawer .rrx-qty input{
        box-sizing: border-box; min-width: 60px; inline-size: max(70, 4.2ch); text-align: center; overflow: visible; width: 56px !important; flex: 0 0 56px !important;
      }
      #rrx-cart-drawer .rrx-qty{ display: flex; gap: 8px; min-width: 120px; overflow: visible; }
      #rrx-cart-drawer .rrx-qty button{ flex: 0 0 36px !important; }

      #rrx-cart-overlay{ z-index:1000001 !important; }
      #rrx-cart-drawer { z-index:1000002 !important; max-height: 100svh; padding-bottom: env(safe-area-inset-bottom, 12px); overflow: hidden; }
      #rrx-cart-drawer .rrx-view{ max-height: calc(100svh - 140px); overflow-y: auto; -webkit-overflow-scrolling: touch; }

      html.rrx-cart-open [class*="announcement"], html.rrx-cart-open [class*="cookie"], html.rrx-cart-open [class*="sticky"], html.rrx-cart-open [data-sticky]{
        display: none !important;
      }
        /* Code ist Eigentum von Rad&Rucksack, Vervielfältigung und Verbreitung strengstens untersagt. */
#rrx-cart-drawer .rrx-rating-wrapper{pointer-events:none!important;cursor:default!important;transform:none!important}
    `;
    document.head.appendChild(s);
    
  }catch(_){}

})();
/* --- SPEEDSHOP: Universal Swipe-to-Close Fix (V7 - Bulletproof State Memory) --- */
document.addEventListener('DOMContentLoaded', () => {
  // 1. CSS Locking (Sichert das Karussell und blockiert Link-Drag)
  const style = document.createElement('style');
  style.textContent = `
    #rrx-cart-drawer, #rrx-qv, #rrx-cart-overlay {
      touch-action: pan-y; 
      overscroll-behavior-x: none !important;
    }
    #rrx-cart-drawer [data-carousel="1"], #rrx-qv .qv-opt-carousel-wrapper {
      touch-action: pan-x pan-y !important; 
    }
    #rrx-cart-drawer img, #rrx-cart-drawer a {
      -webkit-user-drag: none;
      -webkit-touch-callout: none; 
      user-select: none !important; 
      -webkit-tap-highlight-color: transparent !important;
    }
  `;
  document.head.appendChild(style);

  let startX = 0, startY = 0;
  let activeSwipeTarget = null;

  // 2. Touch Start - Mit Edge-Swipe Ignore!
  document.addEventListener('touchstart', (e) => {
    // HIER NEU: #rrx-qv-zoom als erlaubtes Ziel für Wischgesten hinzugefügt
    const target = e.target.closest('#rrx-cart-drawer, #rrx-qv, #rrx-cart-overlay, #rrx-qv-zoom');
    if (!target) return;
    
    startX = e.touches[0].screenX;
    startY = e.touches[0].screenY;
    
    // RACE-CONDITION FIX: System-Edge-Swipes ignorieren
    if (startX < 35 || startX > window.innerWidth - 35) {
       activeSwipeTarget = null;
       return; 
    }
    activeSwipeTarget = target;
  }, { passive: true });

  // 3. Touch Move - JS Blocker
  document.addEventListener('touchmove', (e) => {
    if (!activeSwipeTarget) return;
    // Blockiert das native Schließen, wenn über ein Karussell gewischt wird
    if (e.target.closest('[data-carousel="1"], .qv-opt-carousel-wrapper')) return;

    const touch = e.touches[0];
    const diffX = touch.screenX - startX;
    const diffY = touch.screenY - startY;

    if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 10) {
       e.preventDefault();
    }
  }, { passive: false });

  // 4. Touch End
  const handleSwipeEnd = (e) => {
    // Ignoriert den Swipe-to-Close Befehl, wenn das Ziel ein Karussell ist
    if (!activeSwipeTarget || e.target.closest('[data-carousel="1"], .qv-opt-carousel-wrapper')) {
      activeSwipeTarget = null;
      return;
    }

    const touch = e.changedTouches ? e.changedTouches[0] : (e.touches ? e.touches[0] : null);
    if (!touch) {
      activeSwipeTarget = null;
      return;
    }

    const diffX = touch.screenX - startX;
    const diffY = touch.screenY - startY;
    
    const scrollBody = activeSwipeTarget.querySelector('.rrx-view:not([hidden]), .rrx-qv-body') || activeSwipeTarget;
    const scrollTop = scrollBody.scrollTop || 0;

    const swipedDown = diffY > 40 && Math.abs(diffY) > Math.abs(diffX) && scrollTop <= 10;
    const swipedRight = diffX > 40 && Math.abs(diffX) > Math.abs(diffY); 
    const swipedSide = Math.abs(diffX) > 40 && Math.abs(diffX) > Math.abs(diffY);

    if (activeSwipeTarget.id === 'rrx-qv') {
      if (swipedDown || swipedSide) {
        const closeBtn = activeSwipeTarget.querySelector('.rrx-qv-close');
        if (closeBtn) closeBtn.click();
      }
    } 
    // HIER NEU: Wischgeste für das Zoom-Overlay (nur wenn nicht herangezoomt ist!)
    else if (activeSwipeTarget.id === 'rrx-qv-zoom') {
      const scroll = activeSwipeTarget.querySelector('.zoom-scroll');
      if (scroll && !scroll.classList.contains('is-zoomed')) {
        if (swipedDown || swipedSide) {
          const closeBtn = activeSwipeTarget.querySelector('.zoom-x');
          if (closeBtn) closeBtn.click();
        }
      }
    }
    else if (activeSwipeTarget.id === 'rrx-cart-drawer' || activeSwipeTarget.id === 'rrx-cart-overlay') {
      if (swipedRight) {
        const drawer = document.getElementById('rrx-cart-drawer');
        const closeBtn = drawer ? drawer.querySelector('.rrx-close') : null;
        if (closeBtn) closeBtn.click();
      }
    }
    activeSwipeTarget = null;
  };

  document.addEventListener('touchend', handleSwipeEnd, { passive: true });
  document.addEventListener('touchcancel', handleSwipeEnd, { passive: true });
  
  // 5. BULLETPROOF HISTORY API (Ohne manipulierbare URL)
  const drawer = document.getElementById('rrx-cart-drawer');
  if (drawer) {
    window.rrxDrawerStatePushed = false;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        if (m.attributeName === 'aria-hidden') {
          const isOpen = drawer.getAttribute('aria-hidden') === 'false';
          
          // Öffnen: Unsichtbaren State in die History schieben
          if (isOpen && !window.rrxDrawerStatePushed) {
            window.rrxDrawerStatePushed = true;
            // Der leere String '' verhindert, dass wir die URL verändern
            history.pushState({ rrxCartOpen: true }, '');
          } 
          // Schließen (via Button/JS Swipe): State wieder spurlos entfernen
          else if (!isOpen && window.rrxDrawerStatePushed) {
            window.rrxDrawerStatePushed = false;
            // Prüfen, ob wir wirklich unseren eigenen State löschen
            if (history.state && history.state.rrxCartOpen) {
              window._ignoreRRXPop = true;
              history.back();
              setTimeout(() => { window._ignoreRRXPop = false; }, 200);
            }
          }
        }
      });
    });
    observer.observe(drawer, { attributes: true });

    // Wenn der User mit dem Samsung System-Swipe zurückgeht
    window.addEventListener('popstate', (e) => {
      if (window._ignoreRRXPop) { 
        window._ignoreRRXPop = false; 
        return; 
      }
      if (drawer.getAttribute('aria-hidden') === 'false') {
        window.rrxDrawerStatePushed = false; // System hat den State schon gelöscht
        const closeBtn = drawer.querySelector('.rrx-close');
        if (closeBtn) closeBtn.click();
      }
    });
  }
});
